import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectionType, DatatableComponent } from '@swimlane/ngx-datatable';
import { BylawsService } from 'src/app/services/bylaws.service';
import { ToastService } from 'src/app/toast/toast.service';
import { Modal } from 'bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Action } from 'rxjs/internal/scheduler/Action';
import { ConfigService } from 'src/app/services/auth/config.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { firstValueFrom } from 'rxjs';
@Component({
  selector: 'app-new-amendments',
  templateUrl: './new-amendments.component.html',
  styleUrls: ['./new-amendments.component.scss']
})
export class NewAmendmentsComponent implements OnInit {

  @ViewChild('amendmentsDetailTable') amendmentsDetailTable?: DatatableComponent;
  isVerified: boolean = false;
  statusId: any;
  options = { checkboxes: true }
  applicationModel = 1;
  aplicationDetailList: any
  bylawsProgress: any;
  societyDropdownData: any
  blockDropdownData: any;
  AmendmentsList: any;
  temp: any;
  orderData = [];
  selected: any[] = [];
  AmendmentType: any[] = [];
  selectedRemarkDetails: any;
  remarkList: any;
  value = true
  showDisclamer = false
  ColumnMode = 'ColumnMode';
  SelectionType = SelectionType;
  ExpendeText = '';
  orderColumns: any = [
    { prop: 'id', name: "id", width: 50, sorting: true },
    { prop: 'sByLawsNo', name: 'ByLaws Number', width: 100 },
    { prop: 'sNewByLawsDetail', name: 'byLaws', align: { head: 'center' } },

  ];
  roles: any
  currentUser: any
  columns1: any;
  rolesBlock: number[] = [11, 12, 13];
  rolesSubDivision: number[] = [36, 37, 38];
  printDate: Date = new Date();
  selectionType: 'checkbox' | 'multi' | 'single' = 'checkbox';
  setColumns() {
    this.columns1 = [
      { name: 'Sr.No.', prop: 'id', sortable: false, width: 55 },
          { name: 'Action', prop: 'action', sortable: false },
        { name: 'Status', prop: 'sAuditStatus', sortable: true },
  
      { name: 'Date', prop: 'dCreateDate', sortable: true },
      { name: 'Society Name', prop: 'sSocietyName', sortable: true, width: 400 },
      { name: 'Society Type', prop: 'sName', sortable: true },

      this.rolesSubDivision.includes(this.currentUser.roleId)
        ? 
        ''
        // {
        //   name: 'Sub-Division',
        //   prop: 'sSubDivisionName',
        //   sortable: true,
        // }
        : this.rolesBlock.includes(this.currentUser.roleId)
          ? {
            name: 'Society Block',
            prop: 'SBlockName',
            sortable: true,
          }
          : null,

    
    ].filter(Boolean);
  }

  columns = [
    {
      name: 'SR. No.',
      prop: 'index',
      cellTemplate: 'indexTemplate', // Optional: Can use a custom template if needed
      sortable: false
    },
    {
      name: 'Action',
      prop: 'action',
      cellTemplate: 'actionTemplate',
      sortable: false
    },
    {
      name: 'Amendment Type',
      prop: 'sAmmendmentType',
      cellTemplate: 'amendmentTypeTemplate', // Optional: Can use a custom template if needed
      sortable: true,
      maxWidth: 150
    },
    {
      name: 'Bylaws Number',
      prop: 'sByLawsNo',
      sortable: true,
      maxWidth: 200
    },
    {
      name: 'Bylaws',
      prop: 'sNewByLawsDetail',
      sortable: true,
      maxWidth: 300
    },
    {
      name: 'Existing Bylaws',
      prop: 'sExistByLawsDetail',
      sortable: true,
      maxWidth: 300
    },
    {
      name: 'Liability',
      prop: 'isLiablity',
      cellTemplate: 'liabilityTemplate',
      sortable: true,
      maxWidth: 150
    }
  ];
  byLawsForm!: FormGroup
  updateStatusForm!: FormGroup

  checkboxOptions: any[] = [
    { id: 1, label: "It is not contrary to the provisions of this Act and the Rules." },
    { id: 2, label: "It does not conflict with Co-operative principles." },
    { id: 3, label: "It will promote the economic or social interest of the members of the society." },
    { id: 4, label: "It is not inconsistent with the principles of social justice." }

  ];
  disclamerOptions: any[] = [];
  disclamerOptionsBackup: any[] = [];
  constructor(private fb: FormBuilder, private authService: AuthService, private configService: ConfigService, private ngxUiLoaderService: NgxUiLoaderService, private toastService: ToastService, private sanitizer: DomSanitizer, private byLawsService: BylawsService, private router: Router, private route: ActivatedRoute,) {

  }
  onSelect(selected: any) {

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected?.selected);
  }

  add() {
    this.selected.push(this.orderData[1], this.orderData[3]);
  }

  update() {
    this.selected = [this.orderData[1], this.orderData[3]];
  }

  remove() {
    this.selected = [];
  }


  ngOnInit(): void {
    let user: any = this.authService.currentUserValue
    this.currentUser = user

    this.setColumns();
    this.byLawsForm = this.fb.group({
      societyType: [0, Validators.required],
      // societyBlock: [0, Validators.required],

    })
    this.updateStatusForm = this.fb.group({
      role: ['', Validators.required],
      statusFile: [''],
      status: ['', Validators.required],
      remark: ['', Validators.required],
      checkboxes: this.fb.array([], [this.allCheckboxesRequired()])

    })

    this.getDropDownData();
    this.getSocietyList();
    this.getDisclaimer();
    if (this.currentUser.roleId == 11) {
      this.addCheckbox(this.checkboxOptions)
    } else {
      this.updateStatusForm.removeControl('checkboxes');
    }
    this.getAmendmentType()
  }


  // Getter for the FormArray
  get checkboxes() {
    return this.updateStatusForm.get('checkboxes') as FormArray;
  }

  // Custom validator to check if all checkboxes are selected
  allCheckboxesRequired(): any {
    return (formArray: FormArray): { [key: string]: boolean } | null => {
      if (!formArray || !formArray.controls?.length) {
        return { allRequired: true };
      }
      const expected = this.checkboxOptions?.length || 0;
      const selectedCount = formArray.controls.filter(
        (control) => control.value === true || control.value === 1 || control.value === '1'
      ).length;
      return selectedCount === expected && formArray.controls.length === expected
        ? null
        : { allRequired: true };
    };
  }

  // Function to add checkboxes to the form array
  addCheckbox(option: any): void {
    option.forEach((element: any) => {
      const control = this.fb.control(false); // initially unchecked
      this.checkboxes.push(control);

    });

  }

  /** BI disclaimer checkboxes — rebuild if FormArray empty/broken (e.g. after closeModal). */
  ensureBiCheckboxes(): void {
    if (Number(this.currentUser?.roleId) !== 11) {
      return;
    }
    if (!this.updateStatusForm.get('checkboxes')) {
      this.updateStatusForm.addControl(
        'checkboxes',
        this.fb.array([], [this.allCheckboxesRequired()])
      );
    }
    const arr = this.checkboxes;
    if (!arr) {
      return;
    }
    if (arr.length !== this.checkboxOptions.length) {
      while (arr.length) {
        arr.removeAt(0);
      }
      this.checkboxOptions.forEach(() => {
        arr.push(this.fb.control(false));
      });
    }
    arr.setValidators([this.allCheckboxesRequired()]);
    arr.updateValueAndValidity({ emitEvent: false });
  }

  onBiDisclaimerChange(): void {
    const arr = this.updateStatusForm.get('checkboxes');
    arr?.markAsTouched();
    arr?.updateValueAndValidity({ emitEvent: false });
    this.updateStatusForm.updateValueAndValidity({ emitEvent: false });
  }

  getFileExtension(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.'); // Find the last dot
    return lastDotIndex !== -1
      ? fileName.substring(lastDotIndex + 1).toLowerCase()
      : ''; // Get substring after the last dot
  }
  async onFileSelected(
    event: any,
    fileInput: string,
    form: FormGroup = this.updateStatusForm
  ) {
    const file = event.target.files[0];

    if (file) {
      let fileName = file.name;
      let fileExtension = this.getFileExtension(file.name);

      if (
        fileExtension !== 'jpg' &&
        fileExtension !== 'jpeg' &&
        fileExtension !== 'png' &&
        fileExtension !== 'pdf'
      ) {
        this.toastService.showError(
          'Invalid file type. Allowed types: jpg, jpeg, png, pdf.'
        );
        event.target.value = '';
        return;
      }
      const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB
      if (fileSizeInMB > 2) {
        this.toastService.showError(
          'File size should be less then or equal 2 MB'
        ); // Display error if file size exceeds 2MB
        event.target.value = '';
        return;
      }


      let blob = new Blob([file], { type: file.type })
      let content = await this.blobToBase64(blob);
      let obj = {
        path: fileName,
        content: content
      }

      form.get(fileInput)?.setValue(obj);
    } else {
      form.get(fileInput)?.setValue('');
    }

  }
  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      // When the reader finishes, resolve the promise with the result (Base64 string)
      reader.onloadend = () => {
        resolve(reader.result as string);  // Base64 string is available here
      };

      // Handle any errors
      reader.onerror = (error) => {
        reject(error);
      };

      // Read the Blob as a Data URL (Base64)
      reader.readAsDataURL(blob);
    });
  }
  toggle(check: number) {
    // Amendment Accepted (tab 2) disabled
    if (check === 2) {
      return;
    }
    this.applicationModel = check;
    if (check === 3) {
      this.timelineRemarkPreview = null;
      this.prepareStatusUpdateForm();
    }
  }

  canEditStatusUpdate(): boolean {
    const status = this.aplicationDetailList?.selectedRow?.sAuditStatus;
    return status === 'Pending' || status === 'Progress';
  }

  /** Status update form (Send Back / Move Forward) for logged-in officer only. */
  showStatusUpdatePanel(): boolean {
    if (!this.canEditStatusUpdate()) {
      return false;
    }
    const roleVal = this.updateStatusForm.get('role')?.value;
    const myRole = Number(this.currentUser?.roleId);
    if (
      roleVal !== '' &&
      roleVal != null &&
      Number(roleVal) !== myRole
    ) {
      return false;
    }
    return !this.selectedRemarkDetails?.remark;
  }

  showUpdateButton(): boolean {
    if (!this.showStatusUpdatePanel()) {
      return false;
    }
    const roleVal = this.updateStatusForm.get('role')?.value;
    if (roleVal === '' || roleVal == null) {
      return false;
    }
    return Number(roleVal) === Number(this.currentUser?.roleId);
  }

  /** 1968 AR: certificate upload/generate enabled only when Status = Approved (4). */
  showArCertificateUpload(): boolean {
    return (
      Number(this.currentUser?.roleId) === 13 &&
      String(this.updateStatusForm?.get('status')?.value) === '4'
    );
  }

  /** BI/DI/AR: always show file section (AR controls enable/disable separately). */
  showStatusFileUpload(): boolean {
    const roleId = Number(this.currentUser?.roleId);
    return roleId === 11 || roleId === 12 || roleId === 13;
  }

  /** AR: Send Back / Reject / empty → certificate controls visible but disabled. */
  isArCertificateDisabled(): boolean {
    return (
      Number(this.currentUser?.roleId) === 13 && !this.showArCertificateUpload()
    );
  }

  /** True when Status Details has a selected/generated file (BI/DI/AR). */
  hasStatusFileSelected(): boolean {
    const file = this.updateStatusForm?.get('statusFile')?.value;
    return !!(file?.content);
  }

  onStatusChange(): void {
    if (
      Number(this.currentUser?.roleId) === 13 &&
      String(this.updateStatusForm.get('status')?.value) !== '4'
    ) {
      this.updateStatusForm.get('statusFile')?.setValue('');
    }
  }

  viewStatusDocument(): void {
    const file = this.updateStatusForm.get('statusFile')?.value;
    if (!file?.content) {
      this.toastService.showError('No file available to view.');
      return;
    }
    const name = String(file.path || '').toLowerCase();
    let mime = 'application/pdf';
    if (name.endsWith('.png')) {
      mime = 'image/png';
    } else if (name.endsWith('.jpg') || name.endsWith('.jpeg')) {
      mime = 'image/jpeg';
    }
    try {
      const blob = this.base64ToBlob(file.content, mime);
      this.base64Pdf = this.sanitizer.bypassSecurityTrustResourceUrl(
        URL.createObjectURL(blob)
      );
      this.openModal('viewStatusDocumentDetails');
    } catch {
      this.toastService.showError('Unable to open the selected file.');
    }
  }

  private enableStatusUpdateControls(): void {
    this.updateStatusForm.controls['remark']?.enable({ emitEvent: false });
    this.updateStatusForm.controls['statusFile']?.enable({ emitEvent: false });
    this.updateStatusForm.controls['status']?.enable({ emitEvent: false });
  }

  private disableStatusUpdateControls(): void {
    this.updateStatusForm.controls['remark']?.disable({ emitEvent: false });
    this.updateStatusForm.controls['statusFile']?.disable({ emitEvent: false });
    this.updateStatusForm.controls['status']?.disable({ emitEvent: false });
  }

  /** Default role + enabled fields when opening Status Details (fixes Update staying disabled). */
  prepareStatusUpdateForm(): void {
    if (!this.canEditStatusUpdate()) {
      return;
    }
    const myRole = Number(this.currentUser?.roleId);
    if (!myRole) {
      return;
    }
    this.selectedRemarkDetails = '';
    this.ensureBiCheckboxes();
    this.updateStatusForm.patchValue(
      { role: myRole },
      { emitEvent: false }
    );
    this.enableStatusUpdateControls();
    this.updateStatusForm.updateValueAndValidity({ emitEvent: false });
  }
  submit() {
    this.getSocietyList();
  }

  amendmentType: any;
  iAreaOperation: any;
  sNOCUpload: any;

  getSocietyList() {

    let id: any
    this.route.paramMap.subscribe((params: any) => {
      id = params.get('id')
    });

    let obj = {
      // IBlockId: this.byLawsForm.value.societyBlock ? this.byLawsForm.value.societyBlock : 0,
      iSTypeid: this.byLawsForm.value.societyType ? Number(this.byLawsForm.value.societyType) : 0,
      action: '',
      iAreaOperation: 0,
      iSubdivision: 0
    }
    if ([11, 13, 12].includes(this.currentUser.roleId)) {
      obj.action = 'GetSocietyDetailbyRoleID',
        obj.iAreaOperation = this.currentUser.iAreaOperation
      obj.iSubdivision = this.currentUser.iSubdivision


    }

    if ([36, 37, 38].includes(this.currentUser.roleId)) {
      obj.action = 'GetSocietyDetailbyRoleID2006',
        obj.iAreaOperation = this.currentUser.iAreaOperation
      obj.iSubdivision = this.currentUser.iSubdivision
    }


    this.ngxUiLoaderService.start();

    this.byLawsService.getSocietyList(obj).subscribe((res: any) => {
      this.ngxUiLoaderService.stop();

      if (res?.status == 200 && res?.data && res?.data.length) {
        this.AmendmentsList = res?.data;
        console.log('this.AmendmentsList', this.AmendmentsList);
        this.amendmentType = Number(
          this.AmendmentsList[0]?.sAmmendmentType);
        this.iAreaOperation = Number(
          this.AmendmentsList[0]?.iAreaOperation);
          this.sNOCUpload = this.AmendmentsList[0]?.sNOCUpload;


        console.log('this.amendmentType', this.amendmentType);
        console.log('sNOCUpload:', this.sNOCUpload);
        console.log('type:', typeof this.amendmentType);
        console.log('condition:', this.amendmentType !== 4);
        if (id) {
          // let field = id == 0 ? 'Pending' : id == 1 ? "Progress" : id == 2 ? 'Move Forward' : id == 3 ? 'Approved' : id == 4 ? 'Rejected' : '';
          let field =
            id == 0 ? 'Pending' :
              id == 1 ? 'Progress' :
                id == 2 ? 'Move Forward' :
                  id == 3 ? 'Approved' :
                    id == 4 ? 'Rejected' :
                      id == 7 ? 'Send Back' :
                        id == 5 ? 'Fees Verification' :
                          id == 6 ? 'Fees Verified' :
                          id == 8 ? 'Certificate Issued' :
                            '';

          // Pending tab: also keep Progress rows (eye-open used to move Pending->Progress)
          if (id == 0) {
            this.AmendmentsList = this.AmendmentsList.filter((i: any) => {
              const status = (i?.sAuditStatus || '').toString();
              return status.includes('Pending') || status.includes('Progress');
            });
          } else if (field) {
            this.AmendmentsList = this.AmendmentsList.filter((i: any) =>
              (i?.sAuditStatus || '').toString().includes(field)
            );
          }
        }
        this.temp = [...this.AmendmentsList]
        //  this.toastService.showSuccess(res?.message)
      } else {
        this.AmendmentsList = [];
        this.temp = [];
        this.toastService.showInfo(res?.message)
      }

    }, (res) => {

      this.ngxUiLoaderService.stop();
      if (res.status != 200) {


      }
    })

  }

  groupedBylaws: any[] = [];

  // comment for just check other things later  open-previous logic code comment By Ranjit
  // groupByType() {

  //   const groups: any = {};

  //   const amendmentMap = new Map(
  //     (this.amendmentsList || []).map(a => [
  //       Number(a.value?.amendmentType),
  //       a.value
  //     ])
  //   );

  //   (this.aplicationDetailList?.byLawsDetailsResponse || []).forEach((item: any) => {


  //     const rawKey = item?.sAmmendmentType ?? item?.sAmendmentType;

  //     const key = Number(rawKey);

  //     const matchedAmendment = amendmentMap.get(key);

  //     if (!groups[key]) {
  //       groups[key] = {
  //         amendmentId: key,
  //         amendmentType: matchedAmendment?.amendmentType ?? key,
  //         bylaws: []
  //       };
  //     }

  //     groups[key].bylaws.push({
  //       amendmentType: matchedAmendment?.amendmentType ?? key,
  //       existingDetails: item?.sExistByLawsDetail || [],
  //       proposedChange: item?.sNewByLawsDetail || [],
  //       purposesChange: item?.reason || []
  //     });

  //   });

  //   this.groupedBylaws = Object.values(groups);

  // }



// Group bylaws by amendment type; break Existing/Proposed into numbered list lines(9/10/2026) -Ranjit
groupByType() {
  const groups: any = {};

    // Only show detail sections for types still in "Amendments Proposed in"
    const allowedTypes = new Set(
      (this.amendmentsList || [])
        .map((a: any) => Number(a?.amendmentType ?? a?.value?.amendmentType))
        .filter((n: number) => !Number.isNaN(n))
    );

  const amendmentMap = new Map(
      (this.amendmentsList || []).map((a: any) => {
        const type = Number(a?.amendmentType ?? a?.value?.amendmentType);
        return [type, a?.value ?? a];
      })
  );

  (this.aplicationDetailList?.byLawsDetailsResponse || []).forEach((item: any) => {
    const rawKey = item?.sAmmendmentType ?? item?.sAmendmentType;
    const key = Number(rawKey);

      // Skip orphan details (e.g. Objectives deleted from registration but old detail still in API)
      if (allowedTypes.size > 0 && !allowedTypes.has(key)) {
        return;
      }

    const matchedAmendment = amendmentMap.get(key);

    if (!groups[key]) {
      groups[key] = {
        amendmentId: key,
        amendmentType: matchedAmendment?.amendmentType ?? key,
        bylaws: []
      };
    }

    groups[key].bylaws.push({
      amendmentType: matchedAmendment?.amendmentType ?? key,
      // Break "1. ... | 2. ..." into list items (Objectives Existing | Proposed)
      existingDetails: this.splitAmendmentLines(item?.sExistByLawsDetail),
      proposedChange: this.splitAmendmentLines(item?.sNewByLawsDetail),
      purposesChange: item?.reason || []
    });
  });

  this.groupedBylaws = Object.values(groups);
}

// Helping method-Split pipe/newline paragraphs into list lines for Existing / Proposed display
private splitAmendmentLines(value: any): string[] {
  if (value == null || value === '') {
    return [];
  }
  const text = Array.isArray(value) ? value.join(' | ') : String(value);
  return text
    .split(/\||\n|\r/)
    .map((s: string) => s.trim().replace(/^\d+\.\s*/, ''))
    .filter((s: string) => !!s);
}

  /** TASK: hide Proposed section when empty — undo if manager asks to revert */
  hasProposedContent(proposed: any): boolean {
    if (proposed == null || proposed === '') {
      return false;
    }
    if (Array.isArray(proposed)) {
      return proposed.some((p: any) => !!String(p ?? '').trim());
    }
    return !!String(proposed).trim();
  }

  groupHasProposed(group: any): boolean {
    return (group?.bylaws || []).some((item: any) =>
      this.hasProposedContent(item?.proposedChange)
    );
  }

  get filteredGoverningMembers() {
    const allowedIds = [14, 15, 16, 89, 125];

  const orderMap: any = {
    14: 1,  // President
    15: 2,  // Vice President
    16: 3,  // Secretary
    89: 4,  // Treasurer
    125: 5, // Executive Member
  //  88: 6   // General Member
  };

  return (this.societyMemberList || [])
    .filter(item =>
      allowedIds.includes(Number(item.iMemDesId))
    )
    .sort((a, b) =>
      orderMap[a.iMemDesId] - orderMap[b.iMemDesId]
    );
  }

  societyMemberList: any[] = [];
  filteredMembers: any[] = [];
  amendmentsList: any[] = [];
  bylawsList: any[] = [];
  uploadedFiles: any = {};
  Uploadedkeys: any[] = [];
  totalAmendmentCount: number = 0;

  // view Application deatils
  getApplicationDetail(data: any) {
    let obj = {
      iByLawsId: data?.iByLawsId,
      iByLawsDetailId: data?.iByLawsId
    }
    this.ngxUiLoaderService.start()

    if ([36, 37, 38].includes(this.currentUser.roleId)) {
      this.byLawsService.getApplicationDetails2006(obj).subscribe((res: any) => {
        if (res?.status == 200 && res?.data) {
          this.aplicationDetailList = res?.data


          this.aplicationDetailList.selectedRow = data
          this.societyMemberList = this.aplicationDetailList.memberList || [];

          this.filteredMembers = [...this.societyMemberList];

          this.amendmentsList = this.aplicationDetailList.amendments || [];


          this.bylawsList = (this.aplicationDetailList.byLawsDetailsResponse || []).map((item: any) => ({
            existingDetails: this.splitAmendmentLines(item.sExistByLawsDetail),
            proposedChange: this.splitAmendmentLines(item.sNewByLawsDetail),
            purposesChange: item.reason
              ? String(item.reason).split(/\n|\|/).map((s: string) => s.trim()).filter(Boolean)
              : []
          }));

          setTimeout(() => {
            this.groupByType();
          }, 1000);

          this.uploadedFiles = {
            FormIV: this.aplicationDetailList.sFormIVPath,
            comparativeChart: this.aplicationDetailList.sComparativeChartPath,
            AuditedAccountReturn: this.aplicationDetailList.sAuditedAccountReturnPath,
            GeneralBodyResolution: this.aplicationDetailList.sGeneralBodyResolutionPath,
            ExecutiveBodyResolution: this.aplicationDetailList.sExecutiveBodyResolutionPath
          };

          this.Uploadedkeys = Object.keys(this.uploadedFiles)
            .filter(key => this.uploadedFiles[key]);


          this.openModal('AmendmentsAppDetails2006')
          this.totalAmendmentCount = this.AmendmentsList
            .filter(
              (item: any) => item.iSocietyDetailsId === data.iSocietyDetailsId
            ).length;
            
        }
        this.ngxUiLoaderService.stop()

      }, (res) => {
        if (res.status != 200) {
          this.ngxUiLoaderService.stop()

        }
      })

      if (data?.sAuditStatus == 'Pending') {
        this.verificatioProcess(data);
      }

      // if (this.currentUser.roleId == 13) {
      //   this.getBindByLawsOrderDetail(data);
      // }
      this.getBindRoles('BindRoles2006');
      //  if (data?.sAuditStatus != 'Pending') {

      this.getbylawsProgressDetail(data, 'ByLawsProgress2006');
      // }

      this.getUserRemarks(data?.iByLawsId, 'GetRemark2006')
    }
    else {
      this.byLawsService.getApplicationDeatails(obj).subscribe((res: any) => {
        if (res?.status == 200 && res?.data) {
          this.aplicationDetailList = res?.data;
          this.aplicationDetailList.selectedRow = data;

          const finishOpen = (details: any[]) => {
            const normalized = (details || []).map((row: any) =>
              this.normalizeAmendmentDetailRow(row)
            );
            // Support both camelCase and PascalCase API payloads
            this.aplicationDetailList.byLawsDetails = normalized;
            this.aplicationDetailList.ByLawsDetails = normalized;

            this.openModal('AmendmentsAppDetails');
           this.totalAmendmentCount = this.AmendmentsList
              ?.filter(
              (item: any) => item.iSocietyDetailsId === data.iSocietyDetailsId
            ).length;

            // ngx-datatable inside a just-opened modal often renders with 0 body height
            setTimeout(() => {
              this.amendmentsDetailTable?.recalculate();
            }, 300);

            this.ngxUiLoaderService.stop();
          };

          const apiDetails =
            res?.data?.byLawsDetails ||
            res?.data?.ByLawsDetails ||
            [];

          // Prefer GetByLaws for detail rows (AmmendmentDetails can return empty/incomplete)
          if (data?.iByLawsId) {
            this.byLawsService.getByLaws(data.iByLawsId).subscribe(
              (gRes: any) => {
                const gDetails =
                  gRes?.status == 200
                    ? gRes?.data?.byLawsDetails ||
                    gRes?.data?.ByLawsDetails ||
                    []
                    : [];
                finishOpen(gDetails.length ? gDetails : apiDetails);
              },
              () => finishOpen(apiDetails)
            );
          } else {
            finishOpen(apiDetails);
          }
        } else {
          this.ngxUiLoaderService.stop();
        }
      }, () => {
        this.ngxUiLoaderService.stop();
      });

      // Do not auto-mark reviewed on eye-view: ReviewApplicationDI moves status
      // from Pending -> Progress and empties NewAmendments/0 list.
      // if (data?.sAuditStatus == 'Pending') {
      //   this.verificatioProcess(data);
      // }

      // Load order bye-law numbers in background for full AR approve (UI tab remains hidden)
      if (this.currentUser.roleId == 13) {
        this.getBindByLawsOrderDetail(data);
      }
      this.getBindRoles('BindRoles');
      // Always load progress trail for officer view
        this.getbylawsProgressDetail(data, 'ByLawsProgress');

      this.getUserRemarks(data?.iByLawsId, 'GetRemark')
    }

  }

  /** Normalize action type fields so Add/Change/Remove render correctly in Application view. */
  normalizeAmendmentDetailRow(row: any): any {
    if (!row) {
      return row;
    }
    const actionType = Number(
      row.sAmmendmentType ??
      row.SAmmendmentType ??
      row.ammendmentType ??
      row.AmmendmentType ??
      row.amendmentType ??
      0
    );
    return {
      ...row,
      sAmmendmentType: actionType || row.sAmmendmentType,
      sAmmendmentTypeSubject:
        row.sAmmendmentTypeSubject ??
        row.SAmmendmentTypeSubject ??
        row.ammendmentTypeSubject,
      sByLawsNo: row.sByLawsNo ?? row.SByLawsNo ?? row.bylawsNumber,
      sNewByLawsDetail:
        row.sNewByLawsDetail ?? row.SNewByLawsDetail ?? row.newBylawsDetails,
      sExistByLawsDetail:
        row.sExistByLawsDetail ??
        row.SExistByLawsDetail ??
        row.existingBylawsDetails
    };
  }


  selectedMember: any
  OpenMemberDetails(member: any) {
    this.selectedMember = member;

  }


  closeModel() {
    this.aplicationDetailList = []
    this.aplicationDetailList.selectedRow = null
    this.applicationModel = 1
    this.updateStatusForm = this.fb.group({
      role: [{ value: '', disabled: false }, Validators.required],
      statusFile: [{ value: '', disabled: false }],
      status: [{ value: '', disabled: false }, Validators.required],
      remark: [{ value: '', disabled: false }, Validators.required],
      checkboxes: this.fb.array([], [this.allCheckboxesRequired()])

    })
    if (this.currentUser.roleId == 11) {
      this.addCheckbox(this.checkboxOptions)
    } else {
      this.updateStatusForm.removeControl('checkboxes');
    }
    this.selectedRemarkDetails = null;
    this.timelineRemarkPreview = null;
    this.remarkList = []
    this.router.navigateByUrl('/dashboard', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/bylaws/NewAmendments']);
    });

  }
  downloadDocument(path: any) {
    if (path) {
      const fileUrl = this.byLawsService.downloadPath(path);
      const link = document.createElement('a');
      link.href = fileUrl;
      link.target = '_blank'; // Open in a new tab
      link.download = fileUrl.split('/').pop() || 'downloaded-file'; // Extract filename from URL
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      this.toastService.showError('Document path is not available');
    }
  }



  // downloadFile(fileName: string) {
   
  //       let fileUrl:any = '';
  //   if(fileName.includes('/')){
  //      fileUrl = this.configService.getFileUrl() + fileName;
  //   }else{
  //      fileUrl = this.configService.getFileUrl() + 'ByLaws/' + fileName;
  //   }
  //   // const fileUrl = this.configService.getFileUrl() + 'ByLaws/' + fileName;
  //   const link = document.createElement('a');
  //   link.href = fileUrl;
  //   link.download = fileName;
  //   link.target = '_blank'; // Optional: specify a file name
  //   link.click();
  // }

  
  downloadFile(fileName: string) {
    debugger;
    let fileUrl: any = '';
    if (fileName.includes('/')) {
       fileUrl = this.configService.getFileUrl() + fileName;
    } else {
       fileUrl = this.configService.getFileUrl() + 'ByLaws/' + fileName;
    }
    // const fileUrl = this.configService.getFileUrl() + 'ByLaws/' + fileName;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank'; // Optional: specify a file name
    link.click();
  }


  getDropDownData() {
    this.byLawsService.getDropDownData1().subscribe(response => {
      if (response?.status === 200 && response?.data) {

        if ([11, 13, 12].includes(this.currentUser.roleId)) {
          this.societyDropdownData = response.data.societyType;
        } else {
          this.societyDropdownData = response.data.societyType2006;
        }


        this.blockDropdownData = response.data.blocks;


      }

    })
  }
  getBindRoles(action: any) {

    this.byLawsService.getBindRoles(action).subscribe(response => {
      if (response?.status === 200 && response?.data) {
        this.roles = response.data;

      }

    })
  }

  timelineRemarkPreview: any = null;
  /** Long View Remark: collapsed by default; Read more expands. */
  remarkPreviewExpanded = false;
  private readonly remarkPreviewCollapseChars = 280;

  isLongRemarkText(text: any): boolean {
    return String(text || '').trim().length > this.remarkPreviewCollapseChars;
  }

  toggleRemarkPreviewExpand(): void {
    this.remarkPreviewExpanded = !this.remarkPreviewExpanded;
  }

  /**
   * Officer View Remark — only on Move Forward / Send Back / Approved.
   * 1968: BI/DI/AR. 2006: DH sees all DH/BO/Reg remarks; BO/Reg hide DH Send Back (Society portal).
   */
  canShowOfficerViewRemark(item: any): boolean {
    const roleId = Number(this.currentUser?.roleId);
    const is1968Officer = [11, 12, 13].includes(roleId);
    const is2006Officer = [36, 37, 38].includes(roleId);
    if (!is1968Officer && !is2006Officer) {
      return false;
    }
    const status = String(item?.AuditStatus || '').toLowerCase();
    const roleName = String(item?.RoleName || '').toLowerCase();

    // Only these statuses
    const isRemarkStatus =
      status.includes('send back') ||
      status.includes('move forward') ||
      status.includes('completed') ||
      status.includes('approved');
    if (!isRemarkStatus) {
      return false;
    }

    if (is2006Officer) {
      const is2006Actor =
        roleName.includes('dealing hand') ||
        roleName.includes('dealing head') ||
        roleName.includes('branch officer') ||
        (roleName.includes('registrar') && !roleName.includes('assistant'));
      if (!is2006Actor) {
        return false;
      }
      // DH Send Back link: Dealing Hand + Society; not BO/Registrar
      if (
        status.includes('send back') &&
        (roleName.includes('dealing hand') || roleName.includes('dealing head')) &&
        roleId !== 36
      ) {
        return false;
      }
      return true;
    }

    return !!this.getRemarkPayloadForRoleName(item?.RoleName)?.remark;
  }

  /** True if dash sRemarks is real officer text (not system message). */
  private isOfficerDashRemarkText(text: any): boolean {
    const t = String(text || '').trim();
    if (!t) {
      return false;
    }
    const lower = t.toLowerCase();
    return !(
      lower.startsWith('application sent back') ||
      lower.startsWith('application sendback') ||
      lower.startsWith('application move') ||
      lower.startsWith('bylaws') ||
      lower.startsWith('bye-laws')
    );
  }

  private timelineRemarkKey(item: any): string {
    return [
      String(item?.RoleName || ''),
      String(item?.AuditStatus || ''),
      String(item?.dCreatedDate || '')
    ].join('|');
  }

  /** Per-row remark from GetRemark2006 when timeline date matches officer remark date. */
  private get2006RemarkFromMasterByTimelineRow(
    item: any,
    roleName: string
  ): { remark: string; remarkDate: any; FilePath: any } | null {
    const role = roleName.toLowerCase();
    let remark: string | undefined;
    let remarkDate: any;
    let filePath: any;
    if (role.includes('dealing hand') || role.includes('dealing head')) {
      remark = this.remarkList?.sDealingHeadRemark;
      remarkDate = this.remarkList?.dDealingHeadRemarkDate;
      filePath = this.remarkList?.sDealingHeadDocument;
    } else if (role.includes('branch officer')) {
      remark = this.remarkList?.sBranchOfficerRemark;
      remarkDate = this.remarkList?.dBranchOfficerRemarkDate;
      filePath = this.remarkList?.sBranchOfficerDocument;
    } else if (role.includes('registrar') && !role.includes('assistant')) {
      remark = this.remarkList?.sRegistrarRemark;
      remarkDate = this.remarkList?.dRegistrarRemarkDate;
      filePath = this.remarkList?.sRegistrarDocument;
    } else {
      return null;
    }
    const latestRemark = String(remark || '').trim();
    if (
      latestRemark &&
      this.isSameCalendarDate(item?.dCreatedDate, remarkDate)
    ) {
      return {
        remark: latestRemark,
        remarkDate,
        FilePath: filePath ?? null
      };
    }
    return null;
  }

  /** Compare calendar dates only (ignore time). */
  private isSameCalendarDate(a: any, b: any): boolean {
    if (a == null || b == null) {
      return false;
    }
    const da = new Date(a);
    const db = new Date(b);
    if (Number.isNaN(da.getTime()) || Number.isNaN(db.getTime())) {
      return false;
    }
    return (
      da.getFullYear() === db.getFullYear() &&
      da.getMonth() === db.getMonth() &&
      da.getDate() === db.getDate()
    );
  }

  private getRemarkPayloadForRoleName(roleName: any): any | null {
    const role = String(roleName || '').toLowerCase();
    // ——— 1968 ———
    if (role.includes('block inspector') && this.remarkList?.sBlockInspectorRemark) {
      return {
        remark: this.remarkList.sBlockInspectorRemark,
        remarkDate: this.remarkList.dBlockInspectorRemarkDate,
        FilePath: this.remarkList.sBlockInspectorDocument,
        roleName
      };
    }
    if (
      (role.includes('district') || role.includes('dao')) &&
      this.remarkList?.sDistrictAuditOfficerRemark
    ) {
      return {
        remark: this.remarkList.sDistrictAuditOfficerRemark,
        remarkDate: this.remarkList.dDistrictAuditOfficerRemarkDate,
        FilePath: this.remarkList.sDistrictAuditOfficerDocument,
        roleName
      };
    }
    if (
      role.includes('assistant registrar') &&
      this.remarkList?.sAssistantRegistrarRemark
    ) {
      return {
        remark: this.remarkList.sAssistantRegistrarRemark,
        remarkDate: this.remarkList.dAssistantRegistrarRemarkDate,
        FilePath: this.remarkList.sAssistantRegistrarDocument,
        roleName
      };
    }
    // ——— 2006 (shareable remarks via GetRemark2006) ———
    if (
      (role.includes('dealing hand') || role.includes('dealing head')) &&
      this.remarkList?.sDealingHeadRemark
    ) {
      return {
        remark: this.remarkList.sDealingHeadRemark,
        remarkDate: this.remarkList.dDealingHeadRemarkDate,
        FilePath: this.remarkList.sDealingHeadDocument,
        roleName
      };
    }
    if (role.includes('branch officer') && this.remarkList?.sBranchOfficerRemark) {
      return {
        remark: this.remarkList.sBranchOfficerRemark,
        remarkDate: this.remarkList.dBranchOfficerRemarkDate,
        FilePath: this.remarkList.sBranchOfficerDocument,
        roleName
      };
    }
    if (role.includes('registrar') && this.remarkList?.sRegistrarRemark) {
      return {
        remark: this.remarkList.sRegistrarRemark,
        remarkDate: this.remarkList.dRegistrarRemarkDate,
        FilePath: this.remarkList.sRegistrarDocument,
        roleName
      };
    }
    return null;
  }

  viewTimelineRemark(item: any): void {
    const key = this.timelineRemarkKey(item);
    // Same timeline row again → close
    if (
      this.timelineRemarkPreview?.remark &&
      this.timelineRemarkPreview?._key === key
    ) {
      this.closeTimelineRemark();
      return;
    }

    this.remarkPreviewExpanded = false;
    const roleName = String(item?.RoleName || '');
    // Prefer per-row dash remark (each Move Forward / Send Back stores its own text)
    const dashRemark = String(item?.sRemarks ?? item?.SRemarks ?? '').trim();
    if (this.isOfficerDashRemarkText(dashRemark)) {
      this.selectedRemarkDetails = '';
      this.timelineRemarkPreview = {
        remark: dashRemark,
        remarkDate: item?.dCreatedDate,
        FilePath: null,
        roleName,
        _key: key,
        auditStatus: item?.AuditStatus
      };
      return;
    }

    const fromMaster = this.get2006RemarkFromMasterByTimelineRow(item, roleName);
    if (fromMaster) {
      this.selectedRemarkDetails = '';
      this.timelineRemarkPreview = {
        ...fromMaster,
        roleName,
        _key: key,
        auditStatus: item?.AuditStatus
      };
      return;
    }

    const payload = this.getRemarkPayloadForRoleName(item?.RoleName);
    if (payload?.remark) {
      this.selectedRemarkDetails = '';
      this.timelineRemarkPreview = {
        ...payload,
        _key: key,
        auditStatus: item?.AuditStatus
      };
      return;
    }

    this.selectedRemarkDetails = '';
    this.timelineRemarkPreview = {
      remark: 'not remark added',
      remarkDate: item?.dCreatedDate,
      FilePath: null,
      roleName,
      _key: key,
      auditStatus: item?.AuditStatus
    };
  }

  /** Close remark panel  */
  closeTimelineRemark(): void {
    this.timelineRemarkPreview = null;
    this.selectedRemarkDetails = '';
    this.remarkPreviewExpanded = false;
    this.prepareStatusUpdateFormAfterRemarkClose();
  }

  /** Reset filter after closing timeline remark (role = logged-in officer, empty status/remark). */
  private prepareStatusUpdateFormAfterRemarkClose(): void {
    if (!this.canEditStatusUpdate()) {
      return;
    }
    const myRole = Number(this.currentUser?.roleId);
    if (!myRole) {
      return;
    }
    this.ensureBiCheckboxes();
    this.updateStatusForm.patchValue(
      { role: myRole, remark: '', status: '', statusFile: '' },
      { emitEvent: false }
    );
    this.enableStatusUpdateControls();
    this.updateStatusForm.updateValueAndValidity({ emitEvent: false });
  }

  changeRole(event: any) {
    const val = Number(event.target.value);
    const myRole = Number(this.currentUser?.roleId);
    this.selectedRemarkDetails = null;
    this.timelineRemarkPreview = null;

    if ([11, 12, 13, 12].includes(this.currentUser.roleId)) {
      if (val === 11) {
        this.remarkList?.IsBlockInspectorRemark && (this.selectedRemarkDetails = {
          'remark': this.remarkList?.sBlockInspectorRemark,
          'remarkDate': this.remarkList?.dBlockInspectorRemarkDate,
          'FilePath': this.remarkList?.sBlockInspectorDocument

        })

        // this.updateStatusForm.controls['remark'].setValue(this.remarkList.sBlockInspectorRemark)
      } else if (val === 12) {
        this.remarkList?.sDistrictAuditOfficerRemark && (this.selectedRemarkDetails = {
          'remark': this.remarkList?.sDistrictAuditOfficerRemark,
          'remarkDate': this.remarkList?.dDistrictAuditOfficerRemarkDate,
          'FilePath': this.remarkList?.sDistrictAuditOfficerDocument

        })
      } else {
        this.remarkList?.IsAssistantRegistrarRemark && (this.selectedRemarkDetails = {
          'remark': this.remarkList?.sAssistantRegistrarRemark,
          'remarkDate': this.remarkList?.dAssistantRegistrarRemarkDate,
          'FilePath': this.remarkList?.sAssistantRegistrarDocument

        })
        // this.updateStatusForm.controls['remark'].setValue(this.remarkList.sAssistantRegistrarRemark)
      }
    }
    if ([36, 37, 38].includes(this.currentUser.roleId)) {
      if (val === 36) {
        this.remarkList?.IsDealingHeadRemark && (this.selectedRemarkDetails = {
          'remark': this.remarkList?.sDealingHeadRemark,
          'remarkDate': this.remarkList?.dDealingHeadRemarkDate,
          'FilePath': this.remarkList?.sDealingHeadDocument

        })

        // this.updateStatusForm.controls['remark'].setValue(this.remarkList.sBlockInspectorRemark)
      } else if (val === 37) {
        this.remarkList?.IsBranchOfficerRemark && (this.selectedRemarkDetails = {
          'remark': this.remarkList?.sBranchOfficerRemark,
          'remarkDate': this.remarkList?.dBranchOfficerRemarkDate,
          'FilePath': this.remarkList?.sBranchOfficerDocument

        })
      } else {
        this.remarkList?.IsRegistrarRemark && (this.selectedRemarkDetails = {
          'remark': this.remarkList?.sRegistrarRemark,
          'remarkDate': this.remarkList?.dRegistrarRemarkDate,
          'FilePath': this.remarkList?.sRegistrarDocument

        })
        // this.updateStatusForm.controls['remark'].setValue(this.remarkList.sAssistantRegistrarRemark)
      }
    }

    if (val !== myRole) {
      this.updateStatusForm.patchValue(
        { remark: '', status: '', statusFile: '' },
        { emitEvent: false }
      );
      this.disableStatusUpdateControls();
    } else if (this.canEditStatusUpdate()) {
      this.selectedRemarkDetails = '';
      this.enableStatusUpdateControls();
    } else {
      this.selectedRemarkDetails = '';
      this.updateStatusForm.patchValue(
        { remark: '', status: '', statusFile: '' },
        { emitEvent: false }
      );
      this.disableStatusUpdateControls();
    }
  }

  openAmendmentsModal() {
    // const modalElement = document.getElementById('remarkDetails');
    // if (modalElement) {
    //   const modal = new Modal(modalElement);
    //   modal.show();
    // }
    setTimeout(() => {
      this.openModal('remarkDetails')
    }, 100);
  }
  closeRemarkModel() {
    this.selectedRemarkDetails = ''
    this.hideModal('remarkDetails')
    // setTimeout(() => {
    //   const modalElement = document.getElementById('remarkDetails');
    //   if (modalElement) {
    //     const modal = new Modal(modalElement);
    //     modal.hide();
    //   }
    // }, 100);
  }
  verificatioProcess(data: any) {
    let obj = {
      "iByLawsId": data?.iByLawsId ? data?.iByLawsId : 0,
      "iSocietyDetailsId": data?.iSocietyDetailsId,
      "iRoleID": Number(this.currentUser?.roleId),
      "iUserID": 0,
      "action": (this.currentUser?.roleId == 11) ? 'ReviewApplicationBI' : (this.currentUser?.roleId == 12) ? 'ReviewApplicationDI' : 'ReviewApplicationAR'


    }
    if ([11, 13, 12].includes(this.currentUser.roleId)) {
      obj.action = (this.currentUser?.roleId == 11) ? 'ReviewApplicationBI' : (this.currentUser?.roleId == 12) ? 'ReviewApplicationDI' : 'ReviewApplicationAR'

    }
    if ([36, 37, 38].includes(this.currentUser.roleId)) {
      obj.action = (this.currentUser?.roleId == 36) ? 'ReviewApplicationDH' : (this.currentUser?.roleId == 37) ? 'ReviewApplicationBO' : 'ReviewApplicationRegistrar'
      // ReviewApplicationRegistrar - 38
    }
    this.byLawsService.byLawsVerificationProcess(obj).subscribe((res: any) => {
      if (res?.status == 200) {
        this.toastService.showSuccess(res?.message)
        // this.router.navigate([`/bylaws`]);
        if ([36, 37, 38].includes(this.currentUser.roleId)) {
          this.getbylawsProgressDetail(data, 'ByLawsProgress2006');
        } else {
          this.getbylawsProgressDetail(data, 'ByLawsProgress');
        }

      }

    }, (res) => {

      if (res.status != 200) {

        this.toastService.showError('Something went wrong')
      }
    })
  }
 updateFilter(event: any) {
  const val = (event.target.value || '').trim().toLowerCase();

  this.AmendmentsList = this.temp.filter((d: any) => {
    const societyName = (d.sSocietyName || '').toLowerCase();
    const name = (d.sName || '').toLowerCase();
    const blockName = (d.SBlockName || '').toLowerCase();
    const auditStatus = (d.sAuditStatus || '').toLowerCase();
    const createDate = (d.dCreateDate || '').toString().toLowerCase();

    return (
      societyName.includes(val) ||
      name.includes(val) ||
      blockName.includes(val) ||
      auditStatus.includes(val) ||
      createDate.includes(val)
    );
  });
}


  getUserRemarks(iByLawsId: any, action: any) {

    this.byLawsService.getRemarks(iByLawsId, action).subscribe(res => {

      if (res?.data && res?.data.length > 0) {
        this.remarkList = res?.data[0]

      } else {
        this.remarkList = []

      }


    },
      (error: any) => {
        this.toastService.showError(error.message);
      }
    );
  }

  formatBylaws(text: string | null | undefined): string {
    if (!text) return 'NA';

    return text
      .split('|')
      .map(x => x.trim())
      .filter(x => x)
      .join(', ');
  }


  //   /** Collect scalar bye-law numbers only (never String([]) → '[]'). */
  private collectByLawsNumbers(): string[] {
    const pushScalar = (target: string[], value: any) => {
      if (value == null || value === '') {
        return;
      }
      if (Array.isArray(value)) {
        value.forEach((v) => pushScalar(target, v));
        return;
      }
      if (typeof value === 'object') {
        return;
      }
      const text = String(value).trim();
      if (!text || text === '[]' || text === 'null' || text === 'undefined') {
        return;
      }
      if (!target.includes(text)) {
        target.push(text);
      }
    };

    const result: string[] = [];
    (this.orderData || []).forEach((res: any) => {
      pushScalar(result, res?.sByLawsNo ?? res?.SByLawsNo);
    });
    if (result.length) {
      return result;
    }
    (this.aplicationDetailList?.byLawsDetails || []).forEach((res: any) => {
      pushScalar(result, res?.sByLawsNo ?? res?.SByLawsNo);
    });
    return result;
  }



  private arApproveRetryDone = false;

  updateStatus() {
    const isNocRequest = [36, 37, 38].includes(this.currentUser?.roleId) && Number(this.amendmentType) === 4;

    this.ensureBiCheckboxes();
    if (this.updateStatusForm.invalid) {
      this.updateStatusForm.markAllAsTouched();
      const missing: string[] = [];
      if (this.updateStatusForm.get('role')?.invalid) {
        missing.push('Role');
      }
      if (this.updateStatusForm.get('status')?.invalid) {
        missing.push('Status');
      }
      if (this.updateStatusForm.get('remark')?.invalid) {
        missing.push('Remarks');
      }
      if (this.updateStatusForm.get('checkboxes')?.invalid) {
        missing.push('All disclaimer checkboxes');
      }
      // AR Approved: also mention certificate when form invalid + no file
      if (
        Number(this.currentUser?.roleId) === 13 &&
        String(this.updateStatusForm.get('status')?.value) === '4' &&
        !this.hasStatusFileSelected()
      ) {
        missing.push('Upload Certificate');
      }
      this.toastService.showError(
        missing.length
          ? `Please fill required fields: ${missing.join(', ')}`
          : 'Please complete all required fields before Update.'
      );
      return;
    }

    const formVal = this.updateStatusForm.getRawValue();
    let action = '';
    const roleId = Number(this.currentUser?.roleId);
    const statusVal = Number(formVal?.status);

    // AR + Approved: certificate upload is mandatory before Update
    if (roleId === 13 && statusVal === 4 && !this.hasStatusFileSelected()) {
      this.updateStatusForm.markAllAsTouched();
      const missing: string[] = [];
      if (!String(formVal?.remark || '').trim()) {
        missing.push('Remarks');
      }
      missing.push('Upload Certificate');
      this.toastService.showError(
        `Please fill required fields: ${missing.join(', ')}`
      );
      return;
    }
    if (formVal?.status !== null && formVal?.status !== undefined && formVal?.status !== '') {
      if ([11, 12, 13].includes(roleId)) {
        if (statusVal == 7) {
          action = 'SendBackByLaws'
        } else if (statusVal == 6 && roleId == 13) {
          action = 'ApprovedByLawsByAR'
        } else {
          action = (roleId == 11) ? 'MoveForwardToDI' : (roleId == 13) ? "ApprovedByLawsByAR" : (roleId == 12) ? 'MoveForwardToAR' : ''
        }
      }


      if ([36, 37, 38].includes(roleId)) {
        if (statusVal == 7) {
          action = 'SendBackByLaws2006'
        } else {
          action = (roleId == 36) ? 'MoveForwardToDH' : (roleId == 38) ? "ApprovedByLawsByRegistrar" : (roleId == 37) ? 'MoveForwardToRegistrar' : ''
        }

        if (isNocRequest && Number(this.amendmentType) === 4) {
          if (statusVal == 10 &&
            (this.currentUser?.iAreaOperation === 112 &&
              this.currentUser?.iSubdivision == null) ||
            (this.currentUser?.iAreaOperation === 111 &&
              this.currentUser?.iSubdivision == null )
          ) {
            action = 'RequestForNOCDIS_DH';
          }
          else if (statusVal == 10 &&
            (this.currentUser?.iAreaOperation === 112 &&
              this.currentUser?.iSubdivision == null) ||
            (this.currentUser?.iAreaOperation === 113 &&
              this.currentUser?.iSubdivision != null && this.currentUser?.roleId != 38)
          ) {
            action = 'RequestForNOCOld_DH';
          } else if (this.currentUser?.roleId == 38 && statusVal == 9) {
            action = 'RequestForNOC_Registrar';
          }
          const nocRemark = this.updateStatusForm.value?.remark ? this.updateStatusForm.value?.remark.trim() : '';
          if (!nocRemark) {
            this.toastService.showInfo('Please enter remarks for NOC request.');
            return;
          }
        }
      }
    }

    // Full approve / reject: send all amendment bye-law numbers (no partial checkbox)
    // Never send [] — SQL treats varchar '[]' as invalid int
    let orders: string[] | null = null;
    if (roleId == 13 && (statusVal == 4 || statusVal == 6)) {
      const collected = this.collectByLawsNumbers();
      if (statusVal == 4 && collected.length === 0 && !this.arApproveRetryDone) {
        const row = this.aplicationDetailList?.selectedRow;
        if (row?.iByLawsId) {
          this.arApproveRetryDone = true;
          this.ngxUiLoaderService.start();
          this.byLawsService.getBindByLawsOrderDetail(row).subscribe(
            (res: any) => {
              if (res?.status == 200 && res?.data?.length) {
                this.orderData = res.data;
                this.ngxUiLoaderService.stop();
                this.updateStatus();
              } else if (this.aplicationDetailList?.byLawsDetails?.length) {
                // Fallback: use application detail rows already loaded
                this.ngxUiLoaderService.stop();
                this.updateStatus();
              } else {
                this.arApproveRetryDone = false;
                this.ngxUiLoaderService.stop();
                this.toastService.showError(
                  'No amendment bye-law numbers found to approve. Please reopen the application and try again.'
                );
              }
            },
            () => {
              // Still retry once using byLawsDetails if present
              if (this.aplicationDetailList?.byLawsDetails?.length) {
                this.ngxUiLoaderService.stop();
                this.updateStatus();
              } else {
                this.arApproveRetryDone = false;
                this.ngxUiLoaderService.stop();
                this.toastService.showError('Unable to load amendment orders for approval.');
              }
            }
          );
          return;
        }
        this.toastService.showError(
          'No amendment bye-law numbers found to approve.'
        );
        return;
      }
      if (statusVal == 4 && collected.length === 0) {
        this.arApproveRetryDone = false;
        this.toastService.showError(
          'No amendment bye-law numbers found to approve.'
        );
        return;
      }
      orders = collected.length ? collected : null;
    }

    if (!action) {
      this.toastService.showError('Unable to determine update action for this role/status. Please re-select Role and Status.');
      return;
    }
    if (!Number.isFinite(statusVal) || statusVal <= 0) {
      this.toastService.showError('Please select a valid status (Approved / Reject / Send Back).');
      return;
    }

    const row = this.aplicationDetailList?.selectedRow || {};
    let obj: any = {
      "iByLawsId": Number(row?.iByLawsId ?? row?.IByLawsId) || 0,
      "iByLawsDashId": Number(row?.iByLawsDashId ?? row?.IByLawsDashId) || 0,
      "iSocietyDetailsId": Number(row?.iSocietyDetailsId ?? row?.ISocietyDetailsId) || 0,
      "iRoleID": roleId,
      "iUserID": 0,
      "disclaimer": Array.isArray(formVal?.checkboxes)
        ? (formVal.checkboxes.some((x: any) => !!x) ? '1,2,3,4' : '')
        : '',
      "status": String(statusVal),
      "sRemark": formVal?.remark ? String(formVal.remark).trim() : '',
      "statusDocumentPath": formVal?.statusFile?.content ? formVal.statusFile.content : '',
      "statusDocumentFileName": formVal?.statusFile?.path ? formVal.statusFile.path : '',
      "action": action
    };

    // Only attach sByLawsNo when we have real values (never send [])
    if (roleId == 13 && orders && orders.length > 0) {
      obj.sByLawsNo = orders;
    }

    this.ngxUiLoaderService.start();
    this.byLawsService.upateRemark(obj).subscribe((res: any) => {
      this.ngxUiLoaderService.stop();
      this.arApproveRetryDone = false;
      if (res?.status == 200) {
        this.toastService.showSuccess(res?.message);
        this.router.navigateByUrl('/dashboard', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/bylaws/NewAmendments']);
        });
      } else {
        this.toastService.showError(
          res?.message || 'Unable to update status. Please try again.'
        );
      }

    }, (err) => {
      this.ngxUiLoaderService.stop();
      this.arApproveRetryDone = false;
      this.toastService.showError(
        err?.message || 'Something went wrong while updating status.'
      );
    })
  }







  getDisclaimer() {
    this.byLawsService.getDisclaimer().subscribe(res => {
      if (res?.data && res?.data.length > 0) {
        this.disclamerOptions = res.data;
        this.disclamerOptionsBackup = JSON.parse(JSON.stringify(res?.data))
      }


      //this.toastService.showSuccess(response.message);
    },
      (error: any) => {
        //this.toastService.showError(error.message);
      }
    );
  }
  get filteredMemberList() {
    if (!this.aplicationDetailList?.memberList) {
      return [];
    }
    return this.aplicationDetailList.memberList.filter((v: any) => {
      const desig = (v.sMemberDesignation || '').trim().toLowerCase();
      return desig.includes('president') ||
        desig.includes('vice-president') ||
        desig.includes('treasurer') ||
        desig.includes('secretary') ||
        desig.includes('executive');
    });
  }
  showDiclamer(row: any) {
    this.showDisclamer = true
    this.disclamerOptions = (row.isLiablity == 1) ? JSON.parse(JSON.stringify(this.disclamerOptionsBackup)) : JSON.parse(JSON.stringify(this.disclamerOptionsBackup.slice(2, 4)))
    this.openAmendmentsModal()
    // var objDiv = document.getElementById("disclaimerList") as HTMLElement;
    // // objDiv.scrollTop = objDiv.scrollHeight;
    // objDiv.scrollIntoView({ behavior: "smooth", block: "end" });
  }
  getBindByLawsOrderDetail(data: any) {


    this.byLawsService.getBindByLawsOrderDetail(data).subscribe((res: any) => {
      if (res?.status == 200 && res?.data && res?.data.length > 0) {
        this.orderData = res?.data;
        if (data?.sAuditStatus == "Approved") {
          this.selected = this.orderData.filter((i: any) => i?.IsActive == true);
        }

      } else {
        this.orderData = [];
      }

    }, (res) => {

      if (res.status != 200) {

        this.toastService.showError('Something went wrong')
      }
    })
  }


  getbylawsProgressDetail(data: any, action: any) {
    this.byLawsService.getByLawsProgressDetail(data, action).subscribe((res: any) => {
      if (res?.status == 200 && res?.data && res?.data.length > 0) {
        this.bylawsProgress = res?.data;

      } else {
        this.bylawsProgress = [];
      }

    }, (res) => {

      if (res.status != 200) {

        this.toastService.showError('Something went wrong')
      }
    })
  }

  viewMore(event: any) {
    this.ExpendeText = event
    this.openModal('readMoreModal')
  }
  hideViewMore() {
    this.ExpendeText = ''
    this.hideModal('readMoreModal')
  }
  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }

  getAmendmentType(): void {
    this.byLawsService.Amendsmenttypes().subscribe({
      next: (response: any) => {
        if (response.status === 200) {

          this.AmendmentType = response.data;

        }
      },
      error: (err) => {
        console.error('Failed to fetch amendment types', err);
      }
    });
  }
  typeName(id: any) {
    return this.AmendmentType?.find((a: any) => a.id == id)?.name ?? '';
  }

  getAmendmentActionLabel(row: any): string {
    const t = Number(
      row?.sAmmendmentType ??
      row?.ammendmentType ??
      row?.AmmendmentType ??
      row?.amendmentType ??
      0
    );
    if (t === 1) {
      return 'Add';
    }
    if (t === 2) {
      return 'Change';
    }
    if (t === 3) {
      return 'Remove';
    }
    return 'NA';
  }

  base64Pdf: any = '';
  societyDetails: any = ''
  previewFile(file: any): void {
    if (!file) return;
    const blob = this.base64ToBlob(file.content, "application/pdf");
    this.base64Pdf = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));

    this.openModal('AmendmentsAppDetails')
  }
  base64ToBlob(base64: any, contentType = "", sliceSize = 512): Blob {
    const byteCharacters = atob(base64.split(",")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  formatLabel(value: string): string {
    if (!value) return '';

    return value
      .replace(/([A-Z])/g, ' $1')   // add space before capital letters
      .replace(/^./, str => str.toUpperCase()) // capitalize first letter
      .trim();
  }

  getAmendmentName(id: any): string {
    const amendment = this.AmendmentType.find(a => a.id == id);
    return amendment ? amendment.name : '';
  }

  // printPage() {
  //   // window.print();
  //   this.print('printSection')
  // }


  print() {

    const doc = new jsPDF('p', 'mm', 'a4');

    const primary: [number, number, number] = [41, 128, 185];

    let startY = 15;

    const pageHeight = doc.internal.pageSize.height;

    const checkPageBreak = (extra: number = 10) => {
      if (startY + extra > pageHeight - 10) {
        doc.addPage();
        startY = 15;
      }
    };

    doc.setFont('helvetica', 'bold');
    doc.text('Amendments Application Details', 14, startY);

    startY += 10;

    doc.setFontSize(10);

    doc.setFont('helvetica', 'bold');
    doc.text(`Reference ID:`, 14, startY);

    doc.setFont('helvetica', 'normal');
    doc.text(`${this.aplicationDetailList?.selectedRow?.iByLawsId || '-'}`, 45, startY);

 startY += 6;
        doc.setFont('helvetica', 'bold');
    doc.text(`Society ID:`, 14, startY);

    doc.setFont('helvetica', 'normal');
    doc.text(`${this.aplicationDetailList?.user?.userLoginId || '-'}`, 45, startY);

    startY += 6;

    const rawDate = this.printDate || new Date();
    const date = new Date(rawDate).toLocaleDateString('en-GB');

    doc.setFont('helvetica', 'bold');
    doc.text(`Printed On:`, 14, startY);

    doc.setFont('helvetica', 'normal');
    doc.text(`${date}`, 45, startY);

    startY += 10;

    // ================= SECTION TITLE =================
    const addSectionTitle = (title: string) => {
      checkPageBreak(10);
      doc.setFontSize(11);
      doc.setTextColor(0, 0, 0);
      doc.text(title, 14, startY);
      startY += 6;
    };

    // ================= AUTHORIZED PERSON =================
    addSectionTitle('Details of Authorized Person');

    autoTable(doc, {
      startY,
      head: [['Authorized Person Details', '']],

      body: [
        ['Name', this.aplicationDetailList?.user?.firstName || '-'],
        ['Address', this.aplicationDetailList?.user?.address || '-'],
        ['Mobile', this.aplicationDetailList?.user?.mobile || '-'],
        ['Email', this.aplicationDetailList?.user?.email || '-']
      ],
      theme: 'grid',
      styles: {
        fontSize: 9,
        lineColor: primary,
        lineWidth: 0.2
      },
      headStyles: {
        fillColor: primary,
        textColor: 255
      }
    });

    startY = (doc as any).lastAutoTable.finalY + 10;

    // ================= AMENDMENTS =================
    addSectionTitle('Amendments Proposed In');

    const amendmentRows = (this.amendmentsList || []).map((item: any, i: number) => [
      i + 1,
      this.getAmendmentName(item.amendmentType),
      item.resolutionNo,
      new Date(item.resolutionDate).toLocaleDateString('en-GB')

    ]);

    autoTable(doc, {
      startY,
      head: [['#', 'Amendment', 'Resolution No', 'Date']],
      body: amendmentRows,
      theme: 'grid',
      styles: {
        fontSize: 9,
        lineColor: primary,
        lineWidth: 0.2
      },
      headStyles: {
        fillColor: primary,
        textColor: 255
      }
    });

    startY = (doc as any).lastAutoTable.finalY + 10;

    // ================= BYLAWS GROUP (FIXED OVERFLOW) =================
    // TASK: hide Proposed section when empty — undo if manager asks to revert
    this.groupedBylaws.forEach((group: any, index: number) => {
      if (!this.groupHasProposed(group)) {
        return;
      }
      const letter = String.fromCharCode(97 + index);
      addSectionTitle(
        `${letter}. Amendments in ${this.getAmendmentName(group.amendmentType)}`
      );
      const rows = group.bylaws
        .filter((item: any) => this.hasProposedContent(item.proposedChange))
        .map((item: any) => [
        Array.isArray(item.existingDetails)
          ? item.existingDetails.map((l: string, i: number) => `${i + 1}. ${l}`).join('\n')
          : (item.existingDetails || '-'),
        Array.isArray(item.proposedChange)
          ? item.proposedChange.map((l: string, i: number) => `${i + 1}. ${l}`).join('\n')
          : (item.proposedChange || '-')
      ]);

      autoTable(doc, {
        startY,
        head: [['Existing', 'Proposed']],
        body: rows,
        theme: 'grid',

        styles: {
          fontSize: 8,
          lineColor: primary,
          lineWidth: 0.2,
          overflow: 'linebreak',
          cellPadding: 2
        },

        columnStyles: {
          0: { cellWidth: 90 },
          1: { cellWidth: 90 },
        },

        headStyles: {
          fillColor: primary,
          textColor: 255
        }
      });

      startY = (doc as any).lastAutoTable.finalY + 10;

    });

    // ================= GENERAL BODY MEMBERS =================
    if (this.societyMemberList?.length) {

      addSectionTitle('General Body Members');

      autoTable(doc, {
        startY,

        head: [[
          '#',
          'General Details',
         
          'Age',
       
          'Address',

          'Martial Status',
       
          'Occupation',

        'Admission Fee',

          'Document'
        ]],

        body: this.societyMemberList.map((item: any, i: number) => {

          const parentName =
            item.sGender === 'Male'
              ? item.sFatherName
              : (item.sGender === 'Female' && item.sMaritalStatus === 'Married')
                ? item.sMemHusName
                : item.sFatherName;
              
                const generalDetails =
            `Name : ${item.sMemName} (${item.sMembershiptypename})
     Father's / Husband Name : ${parentName}
     Age : ${item.sMemAge} years,
    //  Gender : ${item.sGender} 
     Occupation : ${item.sOccupation || 'NA'}
     Marital Status : ${item.sMaritalStatus}
      Admission Fee : Rs. ${item.sMemShipFee}`
     
     ;

          return [
            i + 1,
            generalDetails,
            // item.sMemName || '-',
            // item.sMemAge || '-',
            // item.sGender || '-',
            // parentName || '-',
            // item.sOccupation || '-',
            // item.sMemShipFee || 'N/A',
            // item.sMembershiptypename || '-',
            `${item.sAdd1 || ''} ${item.sAdd2 || ''}`.trim(),
            // item.sMemberDesignation || '-',
            'Document Attached'
          ];
        }),

        theme: 'grid',
    rowPageBreak: 'avoid',     // <-- Prevent row splitting
       pageBreak: 'auto',
        styles: {
          fontSize: 8,
          lineColor: primary,
          lineWidth: 0.2
        },

        headStyles: {
          fillColor: primary,
          textColor: 255
        }

      });

      startY = (doc as any).lastAutoTable.finalY + 10;
    }
    // ================= GOVERNING BODY =================
    if (this.filteredGoverningMembers?.length) {

      addSectionTitle('Governing Body Members');

      autoTable(doc, {
        startY,
        head: [['#', 'Name', 'Designation', 'Gender', 'Occupation']],
        body: this.filteredGoverningMembers.map((item: any, i: number) => [
          i + 1,
          item.sMemName,
          item.sMemberDesignation,
          item.sGender,
          item.sOccupation
        ]),
        theme: 'grid',
            rowPageBreak: 'avoid',     // <-- Prevent row splitting
       pageBreak: 'auto',
        styles: {
          fontSize: 8,
          lineColor: primary,
          lineWidth: 0.2
        },
        headStyles: {
          fillColor: primary,
          textColor: 255
        }
      });

      startY = (doc as any).lastAutoTable.finalY + 10;
    }

    // ================= DOCUMENTS =================
    if (this.Uploadedkeys?.length) {

      addSectionTitle('Requisite Documents');

      autoTable(doc, {
        startY,
        head: [['#', 'Document', 'Status']],
        body: this.Uploadedkeys.map((key: any, i: number) => [
          i + 1,
          this.formatLabel(key),
          'Document Attached'
        ]),
        theme: 'grid',
        styles: {
          fontSize: 9,
          lineColor: primary,
          lineWidth: 0.2
        },
        headStyles: {
          fillColor: primary,
          textColor: 255
        }
      });
    }

    // ================= SAVE =================
    doc.save('Amendments_Full_Report.pdf');
  }

  PaymentVerify(row: any) {


    this.byLawsService.VerifyFee().subscribe({
      next: (response: any) => {
        if (response.status === 200) {

          this.AmendmentType = response.data;

        }
      },
      error: (err) => {
        console.error('Failed to fetch amendment types', err);
      }
    });
  }

  // component.ts

  paymentDetails: any = [];
  selectedPayment: any = {};
  @ViewChild('paymentModal') paymentModal: any;
  showVerifyButton: boolean = false;
  GetPaymentVerifyDetails(row: any) {
    this.showVerifyButton =
      row?.sAuditStatus == 'Fees Verification';
    let obj = {
      iByLawsId: row?.iByLawsId,
      iSocietyDetailsId: row?.iSocietyDetailsId
    };

    this.byLawsService.GetPaymentVerifyDetails(obj, 'GetPayment').subscribe({
      next: (response: any) => {
        if (response.status === 200) {

          this.paymentDetails = response.data;

          if (this.paymentDetails.length > 0) {
            this.selectedPayment = this.paymentDetails[0];
          }

          const modalElement = document.getElementById('paymentModal');

          if (modalElement) {
            const modal = new Modal(modalElement);
            modal.show();
          }

        }
      },
      error: (err) => {
        console.error('Failed to fetch payment details', err);
        this.toastService.showError('Failed to fetch payment details');
      }
    });
  }
  verifyPayment() {

    let obj = {
      iByLawsId: this.selectedPayment.iByLawsId,
      iSocietyDetailsId: this.selectedPayment.iSocietyDetailsID
    };

    this.byLawsService.VerifyPayment(obj, 'VerifyPayment').subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          this.toastService.showSuccess('Payment Verified Successfully');
          this.getSocietyList();
        }
      },
      error: (err) => {
        console.error('Failed to verify payment', err);
        this.toastService.showError('Failed to verify payment');
      }
    });
  }

  openCertificate(item: any) {
    // this.selectedCertificateData = item;
    // if (this.societyid === 1) {
    //   this.printCertificate2006()

    // }
    // if (this.societyid !== 1) {
    //   this.printCertificate1968();
  }


  selectedCertificateFile: File | null = null;
  onFileSelect(event: any): void {
    const file = event.target.files?.[0];
    if (!file) return;

    const fileExtension = this.getFileExtension(file.name).toLowerCase();
    const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf'];

    if (!allowedExtensions.includes(fileExtension)) {
      this.toastService.showError(
        'Invalid file type. Allowed types: jpg, jpeg, png, pdf.'
      );
      return;
    }

    const fileSizeInMB = file.size / (1024 * 1024);

    // if (fileSizeInMB > 4) {
    //   this.toastService.showError('File size should be ≤ 4 MB');
    //   return;
    // }

    this.selectedCertificateFile = file;
    this.convertToBase64(file, 1);

  }




  selectedCertificateSociety: any;
  uploadCerificate(row: any) {

    this.selectedCertificateSociety = row;

    // const modalElement = document.getElementById('InspectApplication');

    // if (modalElement) {
    //   const modal = new Modal(modalElement);
    //   modal.show();
    // }

    this.getByLawsOrderCertificate(row)
  }
  certificateList: any;
  OrderCertiftcateData: any
  selectedCertificate: any
  getByLawsOrderCertificate(data: any) {
    let action = 'ByLawsOrderCertificate2006'
    // if (this.societyDetails.iSocietyId == 1) {
    //   action = 'ByLawsOrderCertificate2006'
    // } else {
    //   action = 'ByLawsOrderCertificate'
    // }
    this.ngxUiLoaderService.start();
    this.byLawsService.getByLawsOrderCertificate(data?.iSocietyDetailsId, data?.iByLawsId, action).subscribe((res: any) => {
      this.ngxUiLoaderService.stop();
      if (res?.status == 200 && res?.data && res?.data.length > 0) {

        console.log('res?.data[0]', res?.data[0]);
        this.certificateList = this.buildCertificates(res?.data[0])


        this.openModal('InspectApplication')



      } else {
        this.OrderCertiftcateData = {
          bylaws: [],
          societyName: '',
          societyAddress: '',
          societyRegistrationNo: ''
        }
      }


    }, (res) => {
      this.ngxUiLoaderService.stop();
      if (res.status != 200) {

        this.toastService.showError('Something went wrong')
      }
    })
  }
  // buildCertificates(res: any) {
  //   let byLaws = [];

  //   try {
  //     byLaws = JSON.parse(res?.ByLawsDetails || '[]');
  //   } catch {
  //     byLaws = [];
  //   }

  //   const certificates: any[] = [];

  //   let bylawsList: any[] = [];

  //   byLaws.forEach((item: any) => {

  //     // ✅ NAME
  //     if (item.sAmmendmentType == '1') {
  //       certificates.push({
  //         type: 'NAME',
  //         label: 'Name Change Certificate',
  //         oldName: item.sExistByLawsDetail,
  //         newName: item.sNewByLawsDetail,
  //         societyName: res.sSocietyName,
  //         address: res.sAddress1,
  //         district: res.SDistrictName,
  //         regNo: res.sSocietyRegistrationNo,
  //         regDate: this.formatDate(res.ApprovedDate),
  //         amendDate: this.formatDate(res.ApprovedDate)
  //       });
  //     }

  //     // ✅ ADDRESS
  //     else if (item.sAmmendmentType == '5') {
  //       certificates.push({
  //         type: 'ADDRESS',
  //         label: 'Address Change Certificate',
  //         oldAddress: item.sExistByLawsDetail,
  //         newAddress: item.sNewByLawsDetail,
  //         societyName: res.sSocietyName,
  //         district: res.SDistrictName,
  //         regNo: res.sSocietyRegistrationNo,
  //         regDate: this.formatDate(res.ApprovedDate),
  //         amendDate: this.formatDate(res.ApprovedDate)
  //       });
  //     }

  //     // ✅ BYLAWS → COLLECT ONLY
  //     else {
  //       bylawsList.push({
  //         old: item.sExistByLawsDetail,
  //         new: item.sNewByLawsDetail
  //       });
  //     }

  //   });

  //   // ✅ ADD SINGLE BYLAWS CERTIFICATE
  //   if (bylawsList.length > 0) {
  //     certificates.push({
  //       type: 'BYLAWS',
  //       label: 'Bylaws Amendment Certificate',
  //       bylawsList: bylawsList, // 🔥 ALL DATA HERE

  //       societyName: res.sSocietyName,
  //       address: res.sAddress1,
  //       district: res.SDistrictName,
  //       regNo: res.sSocietyRegistrationNo,
  //       regDate: this.formatDate(res.ApprovedDate),
  //       amendDate: this.formatDate(res.ApprovedDate)
  //     });
  //   }

  //   return certificates;
  // }

  buildCertificates(res: any) {

  let byLaws = [];

  try {
    byLaws = JSON.parse(res?.ByLawsDetails || '[]');
  } catch {
    byLaws = [];
  }

  const amendments = {
    name: false,
    objectives: false,
    rules: false,
    area: false,
    address: false,

    oldName: '',
    newName: '',

    oldAddress: '',
    newAddress: '',
      oldAreaLevel: 0,
      newAreaLevel: 0
  };

  byLaws.forEach((item: any) => {

    switch (item.sAmmendmentType) {

      case '1':
        amendments.name = true;
        amendments.oldName = item.sExistByLawsDetail;
        amendments.newName = item.sNewByLawsDetail;
        break;

      case '2':
        amendments.objectives = true;
        break;

      case '3':
        amendments.rules = true;
        break;

      case '4':
        amendments.area = true;
          amendments.oldAreaLevel = item?.oldAreaLevel;
          amendments.newAreaLevel = item?.newAreaLevel;
        break;

      case '5':
        amendments.address = true;
        amendments.oldAddress = item.sExistByLawsDetail;
        amendments.newAddress = item.sNewByLawsDetail;
        break;
    }
  });

  return [{
    type: 'AMENDMENT',
    label: this.getCertificateLabel(amendments),
    amendments,

    societyName: res.sSocietyName,
    district: res.SDistrictName,
    address: res.sAddress1,
    regNo: res.sSocietyRegistrationNo,
      iAreaOperation: res.iAreaOperation,
    regDate: this.formatDate(res.ApprovedDate),
      sSubDivisionName: res?.sSubDivisionName || '',
      
  //         label: 'Address Change Certificate',

          
  // /       amendDate: this.formatDate(res.ApprovedDate)

    amendDate: this.formatDate(new Date().toString()),
    amendDayText: this.getAmendDayText(new Date())
  }];
}
getAmendDayText(dateValue: any): string {

  const date = new Date(dateValue);

  const day = date.getDate();

  let suffix = 'th';

  if (day % 10 === 1 && day !== 11) {
    suffix = 'st';
  } else if (day % 10 === 2 && day !== 12) {
    suffix = 'nd';
  } else if (day % 10 === 3 && day !== 13) {
    suffix = 'rd';
  }

  const month = date.toLocaleString('en-US', {
    month: 'long'
  });

  const year = date.getFullYear();

  return `<b>${day}${suffix}</b> day of <b>${month} ${year}</b>`;
}

getCertificateLabel(amendments: any): string {

  const parts: string[] = [];

  if (amendments.name) {
    parts.push('Name');
  }

  if (amendments.address) {
    parts.push('Address');
  }

  if (amendments.objectives) {
    parts.push('Objectives');
  }

  if (amendments.rules) {
    parts.push('Rules & Regulations');
  }

  if (amendments.area) {
    parts.push('Area of Operation');
  }

  return parts.join(' + ') + ' Amendment Certificate';
}
getAmendmentText(a: any): string {

  const items: string[] = [];

  if (a.address) items.push('Address');
  if (a.objectives) items.push('Objectives');
  if (a.rules) items.push('Rules and Regulations');

  if (items.length === 1) {
    return items[0];
  }

  if (items.length === 2) {
    return items.join(' and ');
  }

  return items.slice(0, -1).join(', ')
    + ' and '
    + items[items.length - 1];
}
  openCertificatePopup(res: any) {
    this.certificateList = this.buildCertificates(res);

  }
  formatDate(date: string) {
    if (!date) return '';
    const d = new Date(date);

    return d.toLocaleDateString('en-GB'); // 23/03/2026
  }
  showPopup = false;

  selectCertificate(cert: any) {

    this.selectedCertificate = cert;
    this.openModal('openCertificateDetails')
    this.showPopup = false;
  }
  printCertificate(id: string) {
    const printContents =
      document.getElementById(id)?.outerHTML;

    const popup = window.open('', '_blank');

    popup?.document.write(`
    <html>
      <head>
        <title>Certificate</title>

        <style>
          body{
            margin:0;
            padding:30px;
            font-family: serif;
          }

          .page{
            overflow:visible !important;
            max-height:none !important;
          }

          .logo-section{
            text-align:center;
          }

          .footer{
            display:flex;
            justify-content:flex-end;
          }
        </style>
      </head>

      <body>
        ${printContents}
      </body>
    </html>
  `);

    popup?.document.close();

    setTimeout(() => {
      popup?.print();
    }, 1000);
  }

  /**
   
   * PDF downloads and binds to Status Details statusFile for Update upload.
   */
  async generateCertificate(): Promise<void> {
    if (Number(this.currentUser?.roleId) !== 13) {
      return;
    }
    if (String(this.updateStatusForm.get('status')?.value) !== '4') {
      this.toastService.showError(
        'Please select Approved status before generating certificate.'
      );
      return;
    }

    const selected = this.aplicationDetailList?.selectedRow || {};
    const iSocietyDetailsId = selected.iSocietyDetailsId;
    const iByLawsId = selected.iByLawsId;
    if (!iSocietyDetailsId || !iByLawsId) {
      this.toastService.showError('Application details not loaded. Open the application again.');
      return;
    }

    this.ngxUiLoaderService.start();
    try {
      let certRow: any = null;
      try {
        const res: any = await firstValueFrom(
          this.byLawsService.getByLawsOrderCertificate(
            iSocietyDetailsId,
            iByLawsId,
            'ByLawsOrderCertificate'
          )
        );
        if (res?.status == 200 && res?.data?.length) {
          certRow = res.data[0];
        }
      } catch {

      }

      if (!certRow) {
        certRow = this.buildCertificateDataFallback(selected);
      }

      await this.render1968AmendmentCertificatePdf(certRow);
      this.toastService.showSuccess('Certificate generated successfully.');
    } catch (e: any) {
      this.toastService.showError(
        e?.message || 'Unable to generate certificate.'
      );
    } finally {
      this.ngxUiLoaderService.stop();
    }
  }

  /** Fallback when SP/API unavailable — use loaded Application Details. */
  private buildCertificateDataFallback(selected: any): any {
    const details =
      this.aplicationDetailList?.byLawsDetails ||
      this.aplicationDetailList?.ByLawsDetails ||
      [];
    return {
      iByLawsId: selected.iByLawsId,
      iSocietyDetailsId: selected.iSocietyDetailsId,
      sSocietyName: selected.sSocietyName || '',
      sAddress1: selected.sAddress1 || '',
      sSocietyRegistrationNo: selected.sSocietyRegistrationNo || '',
      ApprovedDate: selected.ApprovedDate || selected.dtApprovedate || null,
      SDistrictName: selected.SDistrictName || selected.sDistrictName || '',
      SCircleName: selected.SCircleName || selected.sCircleName || '',
      SBlockName: selected.SBlockName || '',
      sVillageName: selected.sVillageName || '',
      sPincode: selected.sPincode || '',
      ByLawsDetails: JSON.stringify(details)
    };
  }

  private parseCertificateDetails(certRow: any): any[] {
    let byLaws: any[] = [];
    try {
      if (typeof certRow?.ByLawsDetails === 'string') {
        byLaws = JSON.parse(certRow.ByLawsDetails || '[]');
      } else if (Array.isArray(certRow?.ByLawsDetails)) {
        byLaws = certRow.ByLawsDetails;
      }
    } catch {
      byLaws = [];
    }
    if (!byLaws.length) {
      byLaws =
        this.aplicationDetailList?.byLawsDetails ||
        this.aplicationDetailList?.ByLawsDetails ||
        [];
    }
    return (byLaws || []).map((r: any) => this.normalizeAmendmentDetailRow(r));
  }

  /** Resolve Amendment In label from subject id (Name / Address / Kind/Type / Liability). */
  private getAmendmentInLabel(subjectId: any): string {
    const fromMaster = (this.typeName(subjectId) || '').trim();
    if (fromMaster) {
      return fromMaster;
    }
    const id = Number(subjectId);
    if (id === 6) {
      return 'Name';
    }
    if (id === 7) {
      return 'Address';
    }
    if (id === 8) {
      return 'Kind/Type';
    }
    if (id === 10) {
      return 'Liability';
    }
    return '';
  }


  private buildDynamicAmendmentClause(
    details: any[],
    societyName: string,
    currentAddress: string
  ): {
    amendmentTypeLabel: string;
    clause: string;
    oldName: string;
    newName: string;
    oldAddress: string;
    newAddress: string;
  } {
    const labels: string[] = [];
    const clauses: string[] = [];
    let oldName = '';
    let newName = '';
    let oldAddress = '';
    let newAddress = '';

    details.forEach((item: any) => {
      const subjectId = Number(item?.sAmmendmentTypeSubject);
      let label = this.getAmendmentInLabel(item?.sAmmendmentTypeSubject);
      // Normalize common master names / ids (6 Name, 7 Address, 8 Kind/Type, 10 Liability)
      if (subjectId === 6 || /^name$/i.test(label)) {
        label = 'Name';
      } else if (subjectId === 7 || /^address$/i.test(label)) {
        label = 'Address';
      } else if (subjectId === 8 || /kind/i.test(label)) {
        label = 'Kind/Type';
      } else if (subjectId === 10 || /liab/i.test(label)) {
        label = 'Liability';
      }
      if (!label || labels.includes(label)) {
        return;
      }
      labels.push(label);
      const exist = String(item?.sExistByLawsDetail || '').trim();
      const neu = String(item?.sNewByLawsDetail || '').trim();

      if (label === 'Name') {
        oldName = exist;
        newName = neu;
        clauses.push(
          `${exist || societyName} has changed its Name to ${neu || '________'}`
        );
      } else if (label === 'Address') {
        oldAddress = exist || currentAddress;
        newAddress = neu;
        clauses.push(
          `${societyName} at ${oldAddress || '________'} has changed its Address to ${neu || '________'}`
        );
      } else if (label === 'Kind/Type') {
        const kindNew =
          neu ||
          [item?.iSKindid, item?.iSTypeid].filter((x) => x != null && x !== '').join(' / ');
        clauses.push(
          `${societyName} has changed its Kind/Type to ${kindNew || '________'}`
        );
      } else if (label === 'Liability') {
        const liab =
          neu ||
          (item?.IsLiablity == 1 || item?.IsLiablity === true
            ? 'Yes'
            : item?.IsLiablity == 0 || item?.IsLiablity === false
              ? 'No'
              : '________');
        clauses.push(
          `${societyName} has changed its Liability to ${liab}`
        );
      }
    });

    return {
      amendmentTypeLabel: labels.join(' / ') || 'Amendment',
      clause: clauses.join('; ') || `${societyName} has been amended`,
      oldName,
      newName,
      oldAddress,
      newAddress
    };
  }

  private formatCertDate(value: any): Date | null {
    if (!value) {
      return null;
    }
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }

  private toOrdinalDay(day: number): string {
    if (day % 10 === 1 && day !== 11) {
      return `${day}st`;
    }
    if (day % 10 === 2 && day !== 12) {
      return `${day}nd`;
    }
    if (day % 10 === 3 && day !== 13) {
      return `${day}rd`;
    }
    return `${day}th`;
  }

  /** e.g. 21 → "Twenty-One" (client Given-under wording). */
  private dayInWords(day: number): string {
    const ones = [
      '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
      'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
      'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const tens = [
      '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
    ];
    if (day < 1 || day > 31) {
      return String(day);
    }
    if (day < 20) {
      return ones[day];
    }
    const t = tens[Math.floor(day / 10)];
    const o = ones[day % 10];
    return o ? `${t}-${o}` : t;
  }

  /** e.g. 2025 → "Two Zero Two Five" (client digit-year style). */
  private yearDigitWords(year: number): string {
    const digitWords = [
      'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'
    ];
    return String(year)
      .split('')
      .map((d) => digitWords[Number(d)] || d)
      .join(' ');
  }

  private yearInWords(year: number): string {
    const ones = [
      '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
      'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
      'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const tens = [
      '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
    ];
    const twoDigits = (n: number): string => {
      if (n < 20) {
        return ones[n];
      }
      return `${tens[Math.floor(n / 10)]}${n % 10 ? ' ' + ones[n % 10] : ''}`.trim();
    };
    if (year < 2000) {
      return `Nineteen ${twoDigits(year - 1900)}`;
    }
    if (year === 2000) {
      return 'Two Thousand';
    }
    if (year < 2100) {
      return `Two Thousand ${twoDigits(year - 2000)}`;
    }
    return String(year);
  }

  private ddMmYyyy(d: Date): string {
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `${dd}/${mm}/${d.getFullYear()}`;
  }

  /**
   * Justified paragraph for 1968 amendment certificate (client PDF match).
   * Full lines: distribute extra space between words.
   * Last line: normal left-aligned spacing.
   */
  private drawJustifiedParagraph(
    pdf: jsPDF,
    text: string,
    x: number,
    y: number,
    maxWidth: number,
    lineHeight: number
  ): number {
    return this.drawJustifiedRichParagraph(
      pdf,
      [{ text: String(text || ''), bold: false }],
      x,
      y,
      maxWidth,
      lineHeight
    );
  }

  /**
   * Justified paragraph with mixed normal/bold runs (client PDF: society name & reg no bold).
   */
  private drawJustifiedRichParagraph(
    pdf: jsPDF,
    segments: Array<{ text: string; bold?: boolean }>,
    x: number,
    y: number,
    maxWidth: number,
    lineHeight: number,
    fontSize: number = 11
  ): number {
    type Token = { word: string; bold: boolean; width: number };
    const tokens: Token[] = [];

    // Bold segments (society name / reg no) must measure with bold font
    // or justification gaps will be wrong and lines look misaligned.
    const measure = (word: string, bold: boolean): number => {
      pdf.setFont('helvetica', bold ? 'bold' : 'normal');
      pdf.setFontSize(fontSize);
      return pdf.getTextWidth(word);
    };

    (segments || []).forEach((seg) => {
      const bold = !!seg?.bold;
      const parts = String(seg?.text || '')
        .split(/(\s+)/)
        .filter((p) => p.length > 0);
      parts.forEach((p) => {
        if (/^\s+$/.test(p)) {
          return;
        }
        tokens.push({ word: p, bold, width: measure(p, bold) });
      });
    });

    if (!tokens.length) {
      return y;
    }

    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(fontSize);
    const normalSpace = pdf.getTextWidth(' ');
    const maxExtraSpace = normalSpace * 2.5;

    const lines: Token[][] = [];
    let current: Token[] = [];
    let currentWidth = 0;

    tokens.forEach((token) => {
      const extra = current.length ? normalSpace : 0;
      if (current.length && currentWidth + extra + token.width > maxWidth) {
        lines.push(current);
        current = [token];
        currentWidth = token.width;
      } else {
        currentWidth += extra + token.width;
        current.push(token);
      }
    });
    if (current.length) {
      lines.push(current);
    }

    lines.forEach((lineTokens, index) => {
      const isLastLine = index === lines.length - 1;
      const wordsWidth = lineTokens.reduce((s, t) => s + t.width, 0);
      const gaps = lineTokens.length - 1;
      let gap = normalSpace;
      if (!isLastLine && gaps > 0) {
        gap = (maxWidth - wordsWidth) / gaps;
        if (gap > normalSpace + maxExtraSpace) {
          gap = normalSpace + maxExtraSpace;
        }
        if (gap < normalSpace) {
          gap = normalSpace;
        }
      }

      let cursor = x;
      lineTokens.forEach((token, i) => {
        pdf.setFont('helvetica', token.bold ? 'bold' : 'normal');
        pdf.setFontSize(fontSize);
        pdf.setTextColor(0, 0, 0);
        pdf.text(token.word, cursor, y);
        cursor += token.width + (i < gaps ? gap : 0);
      });
      y += lineHeight;
    });

    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(fontSize);
    return y;
  }

  private async render1968AmendmentCertificatePdf(certRow: any): Promise<void> {
    const details = this.parseCertificateDetails(certRow);
    const societyName = String(certRow?.sSocietyName || '').trim();
    const addressParts = [
      certRow?.sAddress1,
      certRow?.sVillageName,
      certRow?.SBlockName,
      certRow?.SDistrictName ? `Distt. ${certRow.SDistrictName}` : '',
      certRow?.sPincode ? `H.P. ${certRow.sPincode}` : 'H.P.'
    ].filter((x: any) => !!x && String(x).trim() && String(x).trim() !== '0');
    const presentAddress = addressParts.join(', ');
    const regNo = String(certRow?.sSocietyRegistrationNo || '').trim() || '________';
    const circle =
      String(certRow?.SCircleName || certRow?.sCircleName || '').trim() || '________';
    const district =
      String(certRow?.SDistrictName || '').trim() || '________';

    const regDate =
      this.formatCertDate(certRow?.ApprovedDate) ||
      this.formatCertDate(certRow?.dtApprovedate);
    const amendDate =
      this.formatCertDate(certRow?.dAssistantRegistrarRemarkDate) || new Date();

    const dynamic = this.buildDynamicAmendmentClause(
      details,
      societyName || '________',
      presentAddress
    );

    const pdf = new jsPDF('p', 'pt', 'a4');
    const pageWidth = pdf.internal.pageSize.width;
    const pageHeight = pdf.internal.pageSize.height;
    const margin = 52;
    const contentWidth = pageWidth - margin * 2;
    const centerX = pageWidth / 2;
    const bodyFontSize = 10.5;
    const lineH = 16;
    const sigBottomLimit = pageHeight - 27 - 68; // last sig line <= ~720 on A4

    // Watermark first (behind everything), then double border
    this.drawHpcdWatermark(pdf);
    this.drawCertificateDoubleBorder(pdf);

    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(10.5);
    pdf.setFont('helvetica', 'normal');

    // ——— Prompt 1: Top Header (fixed client spacing) ———
    let y = 55;
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(10);
    pdf.text(`Registration No: ${regNo}`, pageWidth - margin, y, { align: 'right' });

    y = 95;
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(16);
    pdf.text('Certificate of Registration of Cooperative Society', centerX, y, {
      align: 'center'
    });

    y = 120;
    try {
      const logoInfo = await this.loadCertificateLogoWithSize();
      if (logoInfo?.dataUrl) {
        const logoWidth = 90;
        const logoHeight = 70;
        const logoX = pageWidth / 2 - logoWidth / 2;
        pdf.addImage(
          logoInfo.dataUrl,
          'PNG',
          logoX,
          y,
          logoWidth,
          logoHeight
        );
      }
    } catch {
      /* logo optional */
    }

    y = 215;
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(11);
    pdf.setTextColor(0, 0, 0);
    pdf.text('H.P. COOPERATIVE SOCIETIES ACT 1968', centerX, y, { align: 'center' });
    y = 232;
    pdf.setFontSize(10);
    pdf.text('(ACT NO. 3 of 1969)', centerX, y, { align: 'center' });

    // ——— Prompt 2: Body + Given under ———
    y = 275;
    const regDayNum = regDate ? regDate.getDate() : 0;
    const regDay = regDayNum ? this.toOrdinalDay(regDayNum) : '________';
    const regDayWords = regDayNum ? this.dayInWords(regDayNum) : '________';
    const regMonth = regDate
      ? regDate.toLocaleString('en-US', { month: 'long' })
      : '________';
    const regYearDigits = regDate
      ? this.yearDigitWords(regDate.getFullYear())
      : '________';
    const regFull = regDate ? this.ddMmYyyy(regDate) : '________';
    const regYearNum = regDate ? String(regDate.getFullYear()) : '________';
    const regMonthUpper = regDate
      ? regDate.toLocaleString('en-US', { month: 'long' }).toUpperCase()
      : '________';

    y = this.drawJustifiedRichParagraph(
      pdf,
      [
        {
          text:
            'In pursuance of the provision of the Himachal Pradesh Cooperative Societies, Act, 1968(Act No.3 of 1969) ',
          bold: false
        },
        { text: societyName || '________', bold: true },
        {
          text: ` has this (${regFull}) ${regDay} day of ${regMonthUpper} and ${regYearNum} of Registration been registered as No.- `,
          bold: false
        },
        { text: regNo, bold: true },
        { text: '.', bold: false }
      ],
      margin,
      y,
      contentWidth,
      lineH,
      bodyFontSize
    );
    y += 22;

    const givenReg =
      `Given under my hand and seal this ${regDayWords} of ${regMonth} ${regYearNum} ` +
      `${regDay} day of ${regMonth}, ${regYearDigits} (${regFull}) ` +
      `at in the office of the Assistant Registrar Cooperative Societies, ${circle}, Himachal Pradesh.`;
    y = this.drawJustifiedRichParagraph(
      pdf,
      [{ text: givenReg, bold: false }],
      margin,
      y,
      contentWidth,
      lineH,
      bodyFontSize
    );


    y += 50;
    y = this.drawSignatureBlock(pdf, y, pageWidth, circle, district);
    if (y > sigBottomLimit) {
      pdf.addPage();
      this.drawHpcdWatermark(pdf);
      this.drawCertificateDoubleBorder(pdf);
      y = 60;
    }

    // ——— Section 4: Amendment Section Divider ———
    y += 30;
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(13);
    pdf.setTextColor(0, 0, 0);
    pdf.text('Amendment', centerX, y, { align: 'center' });
    const amendTitleW = pdf.getTextWidth('Amendment');
    pdf.setDrawColor(0);
    pdf.setLineWidth(0.8);
    pdf.line(
      centerX - amendTitleW / 2,
      y + 4,
      centerX + amendTitleW / 2,
      y + 4
    );
    y += 20;

    // ——— Section 5: Amendment Body (dynamic bold/normal) ———
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(bodyFontSize);

    const amendDay = this.toOrdinalDay(amendDate.getDate());
    const amendMonth = amendDate.toLocaleString('en-US', { month: 'long' });
    const amendYearWords = this.yearInWords(amendDate.getFullYear());
    const amendFull = this.ddMmYyyy(amendDate);

    const typeLabel = (dynamic.amendmentTypeLabel || '').trim();
    const hasName = /\bName\b/i.test(typeLabel);
    const hasAddress = /\bAddress\b/i.test(typeLabel);
    const oldNameBold = (dynamic.oldName || societyName || '________').trim();
    const oldAddrBold = (
      dynamic.oldAddress ||
      presentAddress ||
      ''
    ).trim();
    const newNameBold = (dynamic.newName || '________').trim();
    const newAddrBold = (dynamic.newAddress || '________').trim();
    const sectionTail =
      ` on ${amendDay} day of ${amendMonth}, ${amendYearWords} (${amendFull}) ` +
      'under the provisions of Section 12(2) of the Himachal Pradesh Cooperative Societies Act, 1968' +
      '(Act No. 3 of 1969) and Rules made there-under.';

    let amendSegments: Array<{ text: string; bold?: boolean }> = [];
    if (hasName && hasAddress) {
      amendSegments = [
        { text: 'This is to certify that ', bold: false },
        {
          text: `${oldNameBold}${oldAddrBold ? ' ' + oldAddrBold : ''}`,
          bold: true
        },
        { text: ' has changed its Name to ', bold: false },
        { text: newNameBold, bold: true },
        { text: ' and its Address to ', bold: false },
        { text: newAddrBold, bold: true },
        { text: sectionTail, bold: false }
      ];
    } else if (hasName) {
      amendSegments = [
        { text: 'This is to certify that ', bold: false },
        {
          text: `${oldNameBold}${oldAddrBold ? ' ' + oldAddrBold : ''}`,
          bold: true
        },
        { text: ' has changed its Name to ', bold: false },
        { text: newNameBold, bold: true },
        { text: sectionTail, bold: false }
      ];
    } else if (hasAddress) {
      amendSegments = [
        { text: 'This is to certify that ', bold: false },
        {
          text: `${societyName || '________'}${oldAddrBold ? ' ' + oldAddrBold : ''}`,
          bold: true
        },
        { text: ' has changed its Address to ', bold: false },
        { text: newAddrBold, bold: true },
        { text: sectionTail, bold: false }
      ];
    } else {
      amendSegments = [
        { text: 'This is to certify that ', bold: false },
        {
          text: `${societyName || '________'}${presentAddress ? ' ' + presentAddress : ''}`,
          bold: true
        },
        {
          text:
            ` has been amended on ${amendDay} day of ${amendMonth}, ${amendYearWords} (${amendFull}) ` +
            'under the provisions of Section 12(2) of the Himachal Pradesh Cooperative Societies Act, 1968' +
            '(Act No. 3 of 1969) and Rules made there-under.',
          bold: false
        }
      ];
    }

    y = this.drawJustifiedRichParagraph(
      pdf,
      amendSegments,
      margin,
      y,
      contentWidth,
      lineH,
      bodyFontSize
    );
    y += 12;

    const givenAmend =
      `Given under my hand and seal on ${amendDay} day of ${amendMonth}, ` +
      `${amendYearWords} (${amendFull}) at ${circle}, Himachal Pradesh.`;
    y = this.drawJustifiedRichParagraph(
      pdf,
      [{ text: givenAmend, bold: false }],
      margin,
      y,
      contentWidth,
      lineH,
      bodyFontSize
    );


    y += 50;
    y = this.drawSignatureBlock(pdf, y, pageWidth, circle, district);
    if (y > sigBottomLimit) {
      pdf.addPage();
      this.drawHpcdWatermark(pdf);
      this.drawCertificateDoubleBorder(pdf);
      y = 60;
    }

    const fileName = `Amendment_Certificate_${certRow?.iByLawsId || 'draft'}.pdf`;
    pdf.save(fileName);

    const blob = pdf.output('blob');
    const content = await this.blobToBase64(blob);
    this.updateStatusForm.get('statusFile')?.setValue({
      path: fileName,
      content
    });
  }

  /** Double border after watermark (outer 20 / inner 26). */
  private drawCertificateDoubleBorder(pdf: jsPDF): void {
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    pdf.setDrawColor(0);
    pdf.setLineWidth(1.2);
    pdf.rect(20, 20, pageWidth - 40, pageHeight - 40);
    pdf.setLineWidth(0.5);
    pdf.rect(26, 26, pageWidth - 52, pageHeight - 52);
  }

  /**
   * HPCD watermark — template-accurate center diagonal.
   * Drawn first (behind border/text). No align:'center' (jsPDF rotates from start point).
   */
  private drawHpcdWatermark(pdf: jsPDF): void {
    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();
    const FONT_SIZE = 144;
    const ANGLE = 45;
    const OPACITY = 0.502;
    const CAP_H = 0.716;

    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(FONT_SIZE);

    let usedGState = false;
    try {
      const gStateCtor = (pdf as any).GState;
      if (typeof gStateCtor === 'function' && typeof (pdf as any).setGState === 'function') {
        pdf.setTextColor(216, 216, 216);
        pdf.setGState(new gStateCtor({ opacity: OPACITY }));
        usedGState = true;
      } else {
        pdf.setTextColor(235, 235, 235);
      }
    } catch {
      pdf.setTextColor(235, 235, 235);
    }

    const w = pdf.getTextWidth('HPCD');
    const rad = (ANGLE * Math.PI) / 180;
    const cos = Math.cos(rad);
    const sin = Math.sin(rad);
    const capH = CAP_H * FONT_SIZE;
    const x = pageW / 2 - (w / 2) * cos + (capH / 2) * sin;
    const y = pageH / 2 + (w / 2) * sin + (capH / 2) * cos;
    pdf.text('HPCD', x, y, { angle: ANGLE });

    if (usedGState) {
      try {
        const gStateCtor = (pdf as any).GState;
        pdf.setGState(new gStateCtor({ opacity: 1 }));
      } catch {
        /* ignore */
      }
    }
    pdf.setTextColor(0, 0, 0);
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(10.5);
  }

  /**
   * Right-aligned AR signature — x = pageWidth - 45 (clear of border).
   * Caller adds y += 50 before call for signature space.
   */
  private drawSignatureBlock(
    pdf: jsPDF,
    y: number,
    pageWidth: number,
    circle: string,
    district: string
  ): number {
    const rightX = pageWidth - 45;
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(10.5);
    pdf.setTextColor(0, 0, 0);
    pdf.text('Assistant Registrar', rightX, y, { align: 'right' });
    y += 16;
    pdf.text('Cooperative Societies (Primary)', rightX, y, { align: 'right' });
    y += 16;
    pdf.text(`${circle}, District ${district}, H.P.`, rightX, y, { align: 'right' });
    return y + 10;
  }

  private loadCertificateLogo(): Promise<string | null> {
    return this.loadCertificateLogoWithSize().then((info) => info?.dataUrl || null);
  }

  /** Logo + natural pixel size for correct aspect ratio (client PDF match). */
  private loadCertificateLogoWithSize(): Promise<{
    dataUrl: string;
    width: number;
    height: number;
  } | null> {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            resolve(null);
            return;
          }
          ctx.drawImage(img, 0, 0);
          resolve({
            dataUrl: canvas.toDataURL('image/png'),
            width: img.width,
            height: img.height
          });
        } catch {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = 'assets/images/logos/hplogo.png';
    });
  }

  async uploadCertificate(): Promise<void> {

    if (!this.selectedCertificateFile) {
      this.toastService.showError('Please select a file.');
      return;
    }

    // const confirmed = await this.alertService.confirmAlert(
    //   'Warning',
    //   'Once uploaded, you cannot upload again.',
    //   'Ok',
    //   'Cancel'
    // );

    // if (!confirmed) return;

    const base64 = await this.convertToBase64(
      this.selectedCertificateFile,
      1
    );

    const payload: any = {

      documentFileName: this.selectedCertificateFile.name,
      certificatePath: this.base64String,
      iByLawsId: this.selectedCertificateSociety?.iByLawsId || '',
      iSocietyDetailsId: this.selectedCertificateSociety?.iSocietyDetailsId || '',


    };

    this.byLawsService.uploadBylawsCertificate(payload).subscribe({
      next: (res: any) => {

        if (res?.status === 200) {

          this.toastService.showSuccess(
            'Certificate uploaded successfully.'
          );

          this.base64String = ''
          this.certificateList = [];
          this.OrderCertiftcateData = null
          this.selectedCertificate = null
          this.selectedCertificateFile = null;
          this.selectedCertificateSociety = null;
          this.hideModal('InspectApplication')
          this.getSocietyList();

        } else {
          this.toastService.showError(res?.message);
        }
      },

      error: (err: any) => {
        this.toastService.showError(
          'Failed to upload certificate.'
        );
        console.error(err);
      }
    });
  }

  base64String: string = '';
  convertToBase64(file: File, from: number): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.base64String = reader.result as string;

    };
  }
  closeModal() {
     this.updateStatusForm = this.fb.group({
      role: ['', Validators.required],
      statusFile: [''],
      status: ['', Validators.required],
      remark: ['', Validators.required],
      checkboxes: this.fb.array([], [this.allCheckboxesRequired()])
    });

    if (Number(this.currentUser?.roleId) === 11) {
      this.addCheckbox(this.checkboxOptions);
    } else {
      this.updateStatusForm.removeControl('checkboxes');
    }
    this.selectedRemarkDetails = '';
    this.applicationModel = 1
  }
}
